/* Lorelia – realistische Live-Vorschau für Foto-Geschenke (Tassen, Textilien, flache Hartware)
 * Stand 05.10.2026 (17:20) · Quelle: Lorelia/personalisierung (werkzeuge/vorschau2, konfiguration/vorschau-parameter.json)
 * 05.10.2026: alle Fotogeschenke mit echtem Basisfoto (vf-basis, Lucas Regel #3182): Ansichten je Henkelseite,
 *   Zaubertasse heiß/kalt, feste Ansicht ohne Drehen bei Fotos mit Henkel, Vordergrund-Ebene (Spirale, Glitzer, Glas),
 *   Maßstab je Größe, deutsche Formatnamen in teeinblues Auswahl (nur Textknoten).
 *
 * NUR MIT TESTSCHALTER AKTIV: localStorage['lr-neu']==='1' (per ?lr_neu=1 setzen, ?lr_neu=0 löscht)
 * oder <script … data-scharf="1">. Ohne Schalter tut die Datei nichts.
 *
 * Grundsätze
 *  - Inhalt ist IMMER das echte Kundenmotiv: teeinblues Artwork-SVG wird per <use> gespiegelt
 *    (kostet nichts, aktualisiert sich selbst). Wir schreiben nie in teeinblues DOM.
 *  - Druckfläche und Platzierung kommen aus den teeinblue-Kampagnendaten der aktiven Variante
 *    (campaign_variants → printarea_ids → campaign_artworks). Die flache Druckansicht zeigt genau das,
 *    was teeinblue in die Druckdatei setzt – inkl. unbedruckter Ränder.
 *  - Licht, Schatten, Glanz und Verformung gibt es nur in der Darstellung, nie in der Druckdatei.
 *  - Zylinder (Tassen): spaltenweise Abwicklung (Streifen mit matrix3d) + Licht-/Glanzkarte aus dem Foto.
 *    Fläche (Decke, Kissen, Puzzle, Anhänger): Homographie bzw. Coons-Netz + Lichtkarte, optional Maske.
 *  - Schärfe-Regel: jede matrix3d-Ebene wird doppelt so groß gezeichnet und per Transform verkleinert.
 *  - Neuere Varianten-/Bildwechsel gewinnen immer (Anfrage-Token), alte Ergebnisse werden verworfen.
 *  - prefers-reduced-motion: keine Dreh-Animation, kein Nachlaufen.
 */
(function () {
  'use strict';
  var D = document, W = window;
  var SKRIPT = D.currentScript;

  /* ---------------- Testschalter ---------------- */
  function schalter() {
    try {
      var q = new URLSearchParams(location.search);
      if (q.get('lr_neu') === '1') localStorage.setItem('lr-neu', '1');
      if (q.get('lr_neu') === '0') localStorage.removeItem('lr-neu');
    } catch (e) {}
    if (SKRIPT && SKRIPT.getAttribute('data-scharf') === '1') return true;
    try { return localStorage.getItem('lr-neu') === '1'; } catch (e) { return false; }
  }
  if (!schalter()) return;
  if (W.LR_VF_GELADEN) return;
  W.LR_VF_GELADEN = true;

  /* ---------------- Parameter (generiert aus konfiguration/vorschau-parameter.json) ---------------- */
  var PARAM = /*LR_VF_PARAMETER_ANFANG*/{"version":"2026-10-08.1","bilder":{"tasse":{"stufen":[1100,1600]},"decke":{"stufen":[1100,1600]},"puzzle":{"stufen":[1100,1600]},"kissen":{"stufen":[1100,1600]},"mauspad":{"stufen":[1100]},"herz":{"stufen":[1100,1600]},"rechteck":{"stufen":[1100,1600]},"emaille-l":{"stufen":[1100]},"emaille-r":{"stufen":[1100]},"herztasse-r":{"stufen":[1100]},"herztasse-l":{"stufen":[1100]},"zauber-warm-r":{"stufen":[1100]},"zauber-warm-l":{"stufen":[1100]},"zauber-kalt-r":{"stufen":[1100]},"zauber-kalt-l":{"stufen":[1100]},"leckerli":{"stufen":[1100]},"napf":{"stufen":[1100]},"notizbuch":{"stufen":[1100]},"laetzchen":{"stufen":[1100]},"hundekissen":{"stufen":[1100]},"schuettel":{"stufen":[1100]},"acrylblock":{"stufen":[1100]},"acrylherz":{"stufen":[1100]},"handtuch":{"stufen":[1100]},"decke2":{"stufen":[1100]},"wandteppich":{"stufen":[1100]},"deckeh":{"stufen":[1100]},"tuchh":{"stufen":[1100]},"teppichh":{"stufen":[1100]},"kugel2":{"stufen":[1100]},"flocke2":{"stufen":[1100]},"tasche2":{"stufen":[1100]}},"basen":{"359864":{"verfahren":"zylinder","bild":"tasse","ebenen":["ohne","henkel","licht","glanz"],"bildB":1760,"bildH":1600,"ausschnitt":[51,270,1556,1370],"grund":"#EEE9E3","zyl":{"cx":803.5,"r":384.5,"oben_y":351,"oben_b":17,"unten_y":1205,"unten_b":76,"thetaMax":88,"streifen":64},"henkel":{"x":1184,"y":431,"b":354,"h":702,"ansatz":1188,"b_mitte":46},"physik":{"umfang_cm":25.76,"hoehe_cm":9.5,"dpi":300},"flaechen_muster":[["PANORAMA",180],["LI_",90],["RE_",270]],"standard_mitte":180,"dev":"Tassenmaße, Henkelseite (links/rechts) und senkrechte Lage der Druckfläche sind Annahmen – merchOne-Vorlage fehlt.","min_anteil":0.5},"359867":{"verfahren":"flaeche","bild":"decke2","ebenen":["basis","licht","maske"],"bildB":1122,"bildH":1402,"ausschnitt":[140,330,1100,1290],"grund":"#E9E8E6","ecken":[[262,522],[1112,302],[1004,1330],[150,1112]],"mitten":[[684,418],[1072,812],[575,1238],[196,816]],"netz":[12,12],"woelbung":0,"dev":"Hochformat: Fleecedecke hängend (Tuch aus dem Handtuch-KI-Foto gestreckt und geglättet) – Darstellung, nicht maßgenau.","min_anteil":0.25,"ansichten":{"quer":{"verfahren":"flaeche","bild":"decke2","ebenen":["basis","licht","maske"],"bildB":1122,"bildH":1402,"ausschnitt":[140,330,1100,1290],"grund":"#E9E8E6","ecken":[[262,522],[1112,302],[1004,1330],[150,1112]],"mitten":[[684,418],[1072,812],[575,1238],[196,816]],"netz":[12,12],"woelbung":0,"massstab":"text"},"hoch":{"verfahren":"flaeche","bild":"deckeh","ebenen":["basis","licht"],"bildB":1122,"bildH":1402,"ausschnitt":[93,66,1038,1390],"grund":"#E9E8E6","ecken":[[145,106],[988,106],[998,1282],[133,1282]],"mitten":null,"netz":null,"woelbung":null,"anpassen":{"foto":0.7168,"cx":566},"massstab":"text"}},"massstab":"text"},"359868":{"verfahren":"flaeche","bild":"decke2","ebenen":["basis","licht","maske"],"bildB":1122,"bildH":1402,"ausschnitt":[140,330,1100,1290],"grund":"#E9E8E6","ecken":[[262,522],[1112,302],[1004,1330],[150,1112]],"mitten":[[684,418],[1072,812],[575,1238],[196,816]],"netz":[12,12],"woelbung":0,"dev":"Hochformat wie Fotodecke; Zickzack-Naht und graue Plüsch-Rückseite der Premium-Decke (merchOne) nicht dargestellt.","min_anteil":0.25,"ansichten":{"quer":{"verfahren":"flaeche","bild":"decke2","ebenen":["basis","licht","maske"],"bildB":1122,"bildH":1402,"ausschnitt":[140,330,1100,1290],"grund":"#E9E8E6","ecken":[[262,522],[1112,302],[1004,1330],[150,1112]],"mitten":[[684,418],[1072,812],[575,1238],[196,816]],"netz":[12,12],"woelbung":0,"massstab":"text"},"hoch":{"verfahren":"flaeche","bild":"deckeh","ebenen":["basis","licht"],"bildB":1122,"bildH":1402,"ausschnitt":[93,66,1038,1390],"grund":"#E9E8E6","ecken":[[145,106],[988,106],[998,1282],[133,1282]],"mitten":null,"netz":null,"woelbung":null,"anpassen":{"foto":0.7168,"cx":566},"massstab":"text"}},"massstab":"text"},"359874":{"verfahren":"flaeche","bild":"kissen","ebenen":["basis","licht"],"bildB":1600,"bildH":1600,"ausschnitt":[110,110,1490,1440],"grund":"#ECE9E2","ecken":[[240,205],[1362,212],[1350,1332],[245,1335]],"mitten":[[800,272],[1295,780],[790,1266],[303,760]],"netz":[12,12],"woelbung":0.1,"min_anteil":0.35},"359869":{"verfahren":"flaeche","bild":"kissen","ebenen":["basis","licht"],"bildB":1600,"bildH":1600,"ausschnitt":[110,110,1490,1440],"grund":"#ECE9E2","ecken":[[240,205],[1362,212],[1350,1332],[245,1335]],"mitten":[[800,272],[1295,780],[790,1266],[303,760]],"netz":[12,12],"woelbung":0.1,"dev":"Basisbild des Baumwollkissens (eigenes Foto des Premium-Kissens fehlt).","min_anteil":0.35},"359866":{"verfahren":"flaeche","bild":"puzzle","ebenen":["basis","licht"],"bildB":1600,"bildH":1600,"ausschnitt":[80,240,1520,1360],"grund":"#ECE9E2","ecken":[[159,319],[1439,319],[1439,1279],[159,1279]],"anpassen":{"foto":1.3333,"cx":799},"raster":{"spalten":20,"zeilen":15,"varianten":{"1032801":[11,8],"1032802":[20,15],"1032803":[25,20],"1032804":[40,25]}},"min_anteil":0.4},"360729":{"verfahren":"flaeche","bild":"mauspad","ebenen":["basis","licht"],"bildB":1246,"bildH":944,"ausschnitt":[0,0,1246,944],"grund":"#FDFDFD","ecken":[[84,68],[1140,76],[1156,825],[68,834]],"radius":26,"anpassen":{"foto":1.3783,"cx":612},"min_anteil":0.5},"359871":{"verfahren":"flaeche","bild":"herz","ebenen":["basis","licht","glanz","maske"],"bildB":1600,"bildH":1600,"ausschnitt":[300,250,1300,1500],"grund":"#EDE8E2","ecken":[[453.5,727],[1137.5,727],[1137.5,1411],[453.5,1411]],"seiten":2,"flaeche_anteil":[0,0.5,1,0.5],"dev":"Druckfläche 567×1146 = zwei Herzseiten (merchOne-PSD): oben 180° gedreht, unten gerade; Ansicht zeigt die untere Hälfte.","min_anteil":0.5},"359872":{"verfahren":"flaeche","bild":"rechteck","ebenen":["basis","licht","glanz"],"bildB":1600,"bildH":1600,"ausschnitt":[360,300,1240,1480],"grund":"#F1EDE7","ecken":[[560,600],[1040,600],[1040,1355],[560,1355]],"radius":25,"dev":"Fenster im Foto 0,64 : 1, Druckfläche 662×898 = 0,74 : 1 – das Foto passt nicht zur Druckfläche (Motiv wird gestaucht). Eigenes Basisbild nötig.","min_anteil":0.5},"359873":{"verfahren":"zylinder","physik":{"umfang_cm":26.6,"hoehe_cm":7.55,"dpi":300},"flaechen_muster":[["PANORAMA",180],["LI_",90],["RE_",270]],"standard_mitte":180,"dev":"Basisfoto KI (vf-basis/emaille), nicht maßgenau; Druckseite links/rechts = Annahme (merchOne-Vorlage fehlt).","min_anteil":0.5,"drehbar":false,"ansichten":{"links":{"bild":"emaille-l","ebenen":["basis","licht","glanz"],"bildB":1122,"bildH":1402,"ausschnitt":[40,260,1000,1140],"grund":"#E9E8E6","zyl":{"cx":576,"r":308,"oben_y":431,"oben_b":57,"unten_y":979,"unten_b":77,"thetaMax":88,"streifen":64},"d":90},"rechts":{"bild":"emaille-r","ebenen":["basis","licht","glanz"],"bildB":1122,"bildH":1402,"ausschnitt":[120,260,1080,1140],"grund":"#E9E8E6","zyl":{"cx":505,"r":311,"oben_y":449,"oben_b":46,"unten_y":1006,"unten_b":79,"thetaMax":88,"streifen":64},"d":270}},"ansicht_regeln":[["LI_","links"],["RE_","rechts"],["PANORAMA","links"]]},"359870":{"verfahren":"zylinder","physik":{"umfang_cm":25.76,"hoehe_cm":9.68,"dpi":300},"flaechen_muster":[["PANORAMA",180],["LI_",90],["RE_",270]],"standard_mitte":180,"dev":"Basisfoto KI (vf-basis/herztasse); Henkel-links-Ansicht = gespiegeltes Foto. Druckseite = Annahme.","min_anteil":0.5,"drehbar":false,"ansichten":{"rechts":{"bild":"herztasse-r","ebenen":["basis","licht","glanz"],"bildB":1122,"bildH":1402,"ausschnitt":[150,200,1122,1120],"grund":"#E9E8E6","zyl":{"cx":502,"r":294,"oben_y":288,"oben_b":32,"unten_y":982,"unten_b":80,"thetaMax":88,"streifen":64},"d":270},"links":{"bild":"herztasse-l","ebenen":["basis","licht","glanz"],"bildB":1122,"bildH":1402,"ausschnitt":[0,200,972,1120],"grund":"#E9E8E6","zyl":{"cx":619,"r":294,"oben_y":288,"oben_b":32,"unten_y":982,"unten_b":80,"thetaMax":88,"streifen":64},"d":90}},"ansicht_regeln":[["LI_","links"],["RE_","rechts"],["PANORAMA","rechts"]]},"359865":{"verfahren":"zylinder","physik":{"umfang_cm":25.76,"hoehe_cm":8.9,"dpi":300},"flaechen_muster":[["PANORAMA",180],["LI_",90],["RE_",270]],"standard_mitte":180,"dev":"Basisfotos KI (vf-basis/zaubertasse warm/kalt); warm: Restband im Foto entfernt. Druckseite = Annahme.","min_anteil":0.5,"drehbar":false,"ansichten":{"rechts":{"bild":"zauber-warm-r","ebenen":["basis","licht","glanz"],"bildB":1122,"bildH":1402,"ausschnitt":[120,280,1100,1200],"grund":"#E9E8E6","zyl":{"cx":491.5,"r":310.5,"oben_y":381,"oben_b":57,"unten_y":1051,"unten_b":81,"thetaMax":88,"streifen":64},"d":270},"links":{"bild":"zauber-warm-l","ebenen":["basis","licht","glanz"],"bildB":1122,"bildH":1402,"ausschnitt":[22,280,1002,1200],"grund":"#E9E8E6","zyl":{"cx":629.5,"r":310.5,"oben_y":381,"oben_b":57,"unten_y":1051,"unten_b":81,"thetaMax":88,"streifen":64},"d":90},"kalt-rechts":{"bild":"zauber-kalt-r","ebenen":["basis"],"bildB":1122,"bildH":1402,"ausschnitt":[120,280,1100,1200],"grund":"#E9E8E6","d":270,"ohne_druck":true},"kalt-links":{"bild":"zauber-kalt-l","ebenen":["basis"],"bildB":1122,"bildH":1402,"ausschnitt":[22,280,1002,1200],"grund":"#E9E8E6","d":90,"ohne_druck":true}},"ansicht_regeln":[["LI_","links"],["RE_","rechts"],["PANORAMA","rechts"]],"kalt_text":"Kalt ist die Tasse schwarz – dein Foto erscheint, sobald heißes Getränk eingefüllt wird."},"360726":{"verfahren":"zylinder","bild":"leckerli","ebenen":["basis","licht","glanz"],"bildB":1122,"bildH":1402,"ausschnitt":[150,170,980,1260],"grund":"#E9E8E6","zyl":{"cx":562,"r":302,"oben_y":350,"oben_b":51,"unten_y":1121,"unten_b":66,"thetaMax":88,"streifen":64},"physik":{"umfang_cm":31.4,"hoehe_cm":12.77,"dpi":300},"flaechen_muster":[["TREAT",180]],"standard_mitte":180,"min_anteil":0.5,"drehbar":true,"ohne_henkel":true},"360725":{"verfahren":"zylinder","bild":"napf","ebenen":["basis","licht","glanz"],"bildB":1122,"bildH":1402,"ausschnitt":[80,380,1040,1130],"grund":"#E9E8E6","zyl":{"cx":559.5,"r":415.5,"oben_y":661,"oben_b":167,"unten_y":846,"unten_b":204,"thetaMax":88,"streifen":64},"physik":{"umfang_cm":58.1,"hoehe_cm":4.12,"dpi":300},"flaechen_muster":[["DOG-BOWL",180]],"standard_mitte":180,"min_anteil":0.5,"drehbar":true,"ohne_henkel":true},"360728":{"verfahren":"flaeche","bild":"notizbuch","ebenen":["basis","licht","vorne"],"bildB":1122,"bildH":1402,"ausschnitt":[90,110,1040,1300],"grund":"#E9E8E6","ecken":[[228,181],[941,206],[905,1233],[196,1197]],"min_anteil":0.5},"360723":{"verfahren":"flaeche","bild":"laetzchen","ebenen":["basis","licht","maske"],"bildB":1122,"bildH":1402,"ausschnitt":[40,60,1082,1330],"grund":"#E9E8E6","ecken":[[94,117],[1022,117],[1022,1273],[94,1273]],"dev":"Lage der Druckfläche 17×19 cm auf dem Lätzchen UNBELEGT (über die ganze Lätzchenform gelegt).","min_anteil":0.5},"360724":{"verfahren":"flaeche","bild":"hundekissen","ebenen":["basis","licht"],"bildB":1122,"bildH":1402,"ausschnitt":[0,300,1122,1130],"grund":"#E9E8E6","ecken":[[40,480],[952,372],[1105,912],[86,1040]],"mitten":[[496,447],[1005,642],[596,962],[107,760]],"netz":[12,12],"woelbung":0.1,"min_anteil":0.35},"360718":{"verfahren":"flaeche","bild":"schuettel","ebenen":["basis","licht","glanz","vorne"],"bildB":1122,"bildH":1402,"ausschnitt":[60,330,1062,1080],"grund":"#E9E8E6","ecken":[[186,448],[978,440],[978,996],[186,1000]],"min_anteil":0.5},"360770":{"verfahren":"flaeche","bild":"acrylblock","ebenen":["basis","licht","glanz","vorne"],"bildB":1122,"bildH":1402,"ausschnitt":[100,230,1040,1200],"grund":"#E9E8E6","ecken":[[248,368],[910,312],[905,1001],[258,1133]],"anpassen":{"foto":1.0,"cx":579,"max":1.55},"dev":"Foto des quadratischen Blocks wird je Format waagrecht angepasst (15×10, 20×15); Druck auf der Rückseite – Näherung.","min_anteil":0.5},"360749":{"verfahren":"flaeche","bild":"acrylherz","ebenen":["basis","licht","glanz","maske"],"bildB":1122,"bildH":1402,"ausschnitt":[120,230,1060,1180],"grund":"#E9E8E6","ecken":[[280,353],[869,353],[869,1070],[280,1070]],"dev":"Herzumriss aus dem KI-Foto; genaue Schnittkontur bei merchOne UNBELEGT.","min_anteil":0.5},"360727":{"verfahren":"flaeche","bild":"handtuch","ebenen":["basis","licht"],"bildB":1122,"bildH":960,"ausschnitt":[0,80,1122,900],"grund":"#E9E8E6","ecken":[[111,186],[1011,186],[1011,754],[111,754]],"anpassen":{"foto":1.5845,"cx":561},"dev":"Hochformat: Handtuch hängend (KI-Foto, je Größe waagrecht angepasst) – Darstellung, nicht maßgenau.","min_anteil":0.25,"ansichten":{"quer":{"verfahren":"flaeche","bild":"handtuch","ebenen":["basis","licht"],"bildB":1122,"bildH":960,"ausschnitt":[0,80,1122,900],"grund":"#E9E8E6","ecken":[[111,186],[1011,186],[1011,754],[111,754]],"anpassen":{"foto":1.5845,"cx":561},"massstab":"text"},"hoch":{"verfahren":"flaeche","bild":"tuchh","ebenen":["basis","licht"],"bildB":1122,"bildH":1402,"ausschnitt":[131,66,999,1390],"grund":"#E9E8E6","ecken":[[183,106],[950,106],[959,1282],[171,1282]],"mitten":null,"netz":null,"woelbung":null,"anpassen":{"foto":0.6522,"cx":566},"massstab":"text"}},"massstab":"text"},"360740":{"verfahren":"flaeche","bild":"wandteppich","ebenen":["basis","licht"],"bildB":1122,"bildH":1402,"ausschnitt":[60,40,1062,820],"grund":"#E9E8E6","ecken":[[168,118],[984,118],[984,705],[168,705]],"anpassen":{"foto":1.3901,"cx":576},"dev":"Hochformat: Stoffbahn an der Stange gezeichnet (Wand aus Basisfoto) – Darstellung, kein Produktfoto.","min_anteil":0.25,"ansichten":{"quer":{"verfahren":"flaeche","bild":"wandteppich","ebenen":["basis","licht"],"bildB":1122,"bildH":1402,"ausschnitt":[60,40,1062,820],"grund":"#E9E8E6","ecken":[[168,118],[984,118],[984,705],[168,705]],"anpassen":{"foto":1.3901,"cx":576},"massstab":"text"},"hoch":{"verfahren":"flaeche","bild":"teppichh","ebenen":["basis","licht"],"bildB":1122,"bildH":1402,"ausschnitt":[86,66,1046,1390],"grund":"#E9E8E6","ecken":[[146,118],[986,118],[986,1290],[146,1290]],"mitten":null,"netz":null,"woelbung":null,"anpassen":{"foto":0.7167,"cx":566},"massstab":"text"}},"massstab":"text"},"360717":{"verfahren":"flaeche","bild":"kugel2","ebenen":["basis","licht","glanz","maske"],"bildB":1122,"bildH":1402,"ausschnitt":[160,330,960,1150],"grund":"#E9E8E6","ecken":[[293.7,503.5],[826.7,503.5],[826.7,1036.5],[293.7,1036.5]],"seiten":2,"flaeche_anteil":[0,0.51119,1,0.48833],"dev":"Druckfläche 1004×2056 = zwei Kreise (merchOne-Vorlage): oben 180° gedreht, unten gerade; Ansicht zeigt den unteren Kreis.","min_anteil":0.5},"360719":{"verfahren":"flaeche","bild":"flocke2","ebenen":["basis","licht","maske"],"bildB":1122,"bildH":1402,"ausschnitt":[150,170,980,1180],"grund":"#E9E8E6","ecken":[[305.2,435.4],[815.2,435.4],[815.2,945.4],[305.2,945.4]],"seiten":2,"flaeche_anteil":[0,0.5,1,0.5],"dev":"Druckfläche 780×1560 = zwei Kreise (merchOne-Vorlage), beide gerade; Ansicht zeigt eine Seite.","min_anteil":0.5},"360731":{"verfahren":"flaeche","bild":"tasche2","ebenen":["basis","licht"],"bildB":1122,"bildH":1402,"ausschnitt":[120,420,1000,1330],"grund":"#E9E8E6","ecken":[[229,550],[885,550],[890,1241],[219,1241]],"mitten":[[557,547],[877,900],[555,1239],[233,900]],"seiten":2,"flaeche_anteil":[0,0,1,0.49989],"dev":"Druckfläche 2363×4725 = Vorder- und Rückseite, Falz = Boden (merchOne-Vorlage); Rückseite 180° gedreht (aus dem Falz abgeleitet); Ansicht zeigt die Vorderseite.","min_anteil":0.5,"ansichten":{"q40":{"verfahren":"flaeche","bild":"tasche2","ebenen":["basis","licht"],"bildB":1122,"bildH":1402,"ausschnitt":[120,420,1000,1330],"grund":"#E9E8E6","ecken":[[229,550],[885,550],[890,1241],[219,1241]],"mitten":[[557,547],[877,900],[555,1239],[233,900]],"seiten":2,"flaeche_anteil":[0,0,1,0.49989],"dev":"Druckfläche 2363×4725 = Vorder- und Rückseite, Falz = Boden (merchOne-Vorlage); Rückseite 180° gedreht (aus dem Falz abgeleitet); Ansicht zeigt die Vorderseite.","min_anteil":0.5},"q70":{"verfahren":"druck","seiten":2,"dev":"Kein Basisfoto für 70×45 – Druckbild: oben Vorderseite, Mitte Bodenfalte (frei), unten Rückseite 180° gedreht."}},"ansicht_regeln":[["40X40","q40"],["70X45","q70"]]}},"produkte":{"11164470542663":{},"11168511230279":{},"11168508051783":{},"11168504054087":{},"11164383674695":{},"11168488653127":{},"11163706818887":{},"11168492552519":{},"11164448948551":{},"11168714490183":{},"11168714391879":{},"11164473491783":{"naeherung":true},"11168495534407":{},"11168498647367":{"verfahren":"druck","dev":"Basis ändert sich gerade (andere Sitzung: Pfotenform-Teppich 364018) – nach Umbau neu prüfen."},"11168697680199":{},"11168500777287":{},"11168712393031":{},"11168713703751":{},"11168713802055":{},"11168714031431":{},"11168714260807":{},"11168763543879":{},"11168771932487":{},"11167968690503":{},"11167969542471":{},"11167966036295":{}}}/*LR_VF_PARAMETER_ENDE*/;

  var ASSET = (SKRIPT && (SKRIPT.getAttribute('data-assets') || String(SKRIPT.src || '').replace(/[^\/?#]*(\?.*)?$/, ''))) || '';
  var NS = 'http://www.w3.org/2000/svg', XL = 'http://www.w3.org/1999/xlink';
  var RUHIG = W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DEV = (function () { try { return new URLSearchParams(location.search).get('lr_vf_dev') === '1'; } catch (e) { return false; } })();
  var NAEHERUNG = (function () { try { return new URLSearchParams(location.search).get('lr_vf_naeherung') === '1' || localStorage.getItem('lr-vf-naeherung') === '1'; } catch (e) { return false; } })();

  var S = {
    camp: null, pid: null, basis: null, bp: null, prod: null,
    variante: null, pa: null, platz: null, artId: null, artVB: null,
    token: 0, modus: 'echt', lupe: false,
    d: 270, dZiel: 270, k: 1, box: null,
    el: {}, strips: [], zellen: [], bildGroesse: 1100, messung: [],
    seiteManuell: null, kalt: false, ansicht: null
  };
  W.LR_VF = S;   // für Tests/Fehlersuche

  /* ---------------- kleine Helfer ---------------- */
  function $(s, r) { return (r || D).querySelector(s); }
  function $$(s, r) { return [].slice.call((r || D).querySelectorAll(s)); }
  function mk(tag, cls, html) { var e = D.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function sv(tag, attrs) { var e = D.createElementNS(NS, tag); for (var k in attrs) e.setAttribute(k, attrs[k]); return e; }
  function rad(g) { return g * Math.PI / 180; }
  function klemme(x, a, b) { return Math.max(a, Math.min(b, x)); }
  /* Kundentaugliche deutsche Namen statt merchOne-Bezeichnungen („Mug Classic - Left Portrait“) */
  var NAMEN = [[/PANORAMA-FULLPRINT|FULL ?PRINT|RUNDUM/i, 'Rundum-Druck'], [/PANORAMA/i, 'Panorama'],
    [/LI_HOCH|LEFT PORTRAIT/i, 'Foto links (hochkant)'], [/LI_QUER|LEFT LANDSCAPE/i, 'Foto links (quer)'],
    [/RE_HOCH|RIGHT PORTRAIT/i, 'Foto rechts (hochkant)'], [/RE_QUER|RIGHT LANDSCAPE/i, 'Foto rechts (quer)']];
  function deutsch(n) {
    n = String(n || '');
    for (var i = 0; i < NAMEN.length; i++) if (NAMEN[i][0].test(n)) return NAMEN[i][1];
    return n.replace(/^(Mug Classic|Mug Emaille|Magic Mug)\s*-?\s*/i, '');
  }
  /* teeinblues Formatnamen in der Auswahl auf Deutsch (nur Textknoten ersetzen – nie in Vues DOM schreiben).
     Preise je Format sind bei allen Tassen gleich; G8 zeigt dann den Gesamtpreis statt des Kachelpreises. */
  var ENGLISCH = /^(Mug Classic|Mug Emaille|Magic Mug)\b.*(Left|Right|Panorama|Full Print)/i;
  /* Größen ohne Zoll, mit „ד und Komma – identisch zu den Shopify-Optionswerten (Umbenennung 05.10.2026),
     damit Gestalter 8 die Kachelpreise weiter zuordnet: „100 x 70 cm / 27" x 40"“ → „100 × 70 cm“ */
  function groesseDeutsch(t) {
    if (t === 'Mouse Pad') return '22 × 18 cm';          // Größe aus der Lieferanten-SKU MAUSPAD-22x18-SLIM
    var s = t.replace(/\s*\/\s*\d+(?:[.,]\d+)?\s*"?\s*[x×]\s*\d+(?:[.,]\d+)?\s*"?\s*$/, '');
    var m = s.match(/^(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)\s*cm$/i);
    if (!m) return null;
    var a = m[1], b = m[2];
    if (S.hoch && parseFloat(a.replace(',', '.')) > parseFloat(b.replace(',', '.'))) { var t2 = a; a = b; b = t2; }   // Hochformat: Breite × Höhe
    return a.replace('.', ',') + ' × ' + b.replace('.', ',') + ' cm';
  }
  /* Hochformat-Produkt: jede Druckfläche der Kampagne trägt (jüngste Zuordnung) ein um 90/270° gedrehtes Motiv */
  function hochBestimmen() {
    var neu = {}; (S.camp && S.camp.campaign_artworks || []).forEach(function (a) { if (!neu[a.printarea_id] || a.id > neu[a.printarea_id].id) neu[a.printarea_id] = a; });
    var k = Object.keys(neu);
    S.hoch = k.length > 0 && k.every(function (id) { return gedreht(neu[id]); });
  }
  function formateDeutsch() {
    var c = $('.tee-campaign'); if (!c) return;
    var w = D.createTreeWalker(c, NodeFilter.SHOW_TEXT), n;
    while ((n = w.nextNode())) {
      var t = n.nodeValue.trim(); if (!t || t.length > 60) continue;
      var de = ENGLISCH.test(t) ? deutsch(t) : (n.parentNode && n.parentNode.closest && n.parentNode.closest('.tee-radio-label, .tee-option') ? groesseDeutsch(t) : null);
      if (de && de !== t) n.nodeValue = n.nodeValue.replace(t, de);
    }
  }
  function ausfuehrungName() {
    var pn = S.pa && (S.pa.display_name || S.pa.name);
    if (pn && NAMEN.some(function (m) { return m[0].test(pn); })) return deutsch(pn);
    try {
      var sid = new URLSearchParams(location.search).get('variant');
      var iv = (S.camp.instance_variants || []).filter(function (x) { return x.variant_id === S.variante.cv.variant_id; })[0];
      var vb = (W.teeinblueCampaign && W.teeinblueCampaign.variantsById) || {};
      var v = vb[(iv && iv.platform_linked_id) || sid];
      if (v) return deutsch((v.options || []).filter(function (o) { return o && o !== 'Default' && o !== 'Standard'; }).slice(-1)[0] || v.public_title || '');
    } catch (e) {}
    return S.variante ? S.variante.cv.size : '';
  }
  function bildUrl(name, art) {
    var b = (PARAM.bilder || {})[name] || {}; var st = b.stufen || [1100];
    var gross = st[st.length - 1], w = st[0];
    for (var i = 0; i < st.length; i++) { w = st[i]; if (st[i] >= S.bildGroesse) break; }
    if (w < S.bildGroesse) w = gross;
    return ASSET + 'lr-vf-' + name + '-' + w + '.' + (art || b.art || 'webp');
  }
  function ladeBild(url) {
    return new Promise(function (ok) {
      var i = new Image(); i.decoding = 'async';
      i.onload = function () { (i.decode ? i.decode().catch(function () {}) : Promise.resolve()).then(function () { ok(i); }); };
      i.onerror = function () { ok(null); };
      i.src = url;
    });
  }

  /* ---------------- Homographie: Rechteck (0,0,w,h) -> Viereck p[ol,or,ur,ul] ---------------- */
  function homographie(w, h, p) {
    var q = [[0, 0], [w, 0], [w, h], [0, h]], A = [], b = [];
    for (var i = 0; i < 4; i++) {
      var x = q[i][0], y = q[i][1], u = p[i][0], v = p[i][1];
      A.push([x, y, 1, 0, 0, 0, -u * x, -u * y]); b.push(u);
      A.push([0, 0, 0, x, y, 1, -v * x, -v * y]); b.push(v);
    }
    for (var c = 0; c < 8; c++) {
      var mx = c;
      for (var r = c + 1; r < 8; r++) if (Math.abs(A[r][c]) > Math.abs(A[mx][c])) mx = r;
      var t = A[c]; A[c] = A[mx]; A[mx] = t; var tb = b[c]; b[c] = b[mx]; b[mx] = tb;
      if (!A[c][c]) return null;
      for (var r2 = c + 1; r2 < 8; r2++) {
        var f = A[r2][c] / A[c][c];
        for (var k = c; k < 8; k++) A[r2][k] -= f * A[c][k];
        b[r2] -= f * b[c];
      }
    }
    var s = new Array(8);
    for (var i2 = 7; i2 >= 0; i2--) { var sum = b[i2]; for (var j = i2 + 1; j < 8; j++) sum -= A[i2][j] * s[j]; s[i2] = sum / A[i2][i2]; }
    return 'matrix3d(' + [s[0], s[3], 0, s[6], s[1], s[4], 0, s[7], 0, 0, 1, 0, s[2], s[5], 0, 1].map(function (v) { return +v.toFixed(8); }).join(',') + ')';
  }

  /* ---------------- teeinblue lesen (nur lesen!) ---------------- */
  function artworkSvg(id) {
    return D.getElementById('tee-artwork-' + id) || null;
  }
  function kampagneLaden() {
    var tc = W.teeinblueCampaign; if (!tc || !tc.productId) return Promise.resolve(null);
    var shop = (W.Shopify && W.Shopify.shop) || (W.teeinblueShop && (W.teeinblueShop.domain || W.teeinblueShop.shop)) || '';
    var url = 'https://api.teeinblue.com/api/merchant/campaigns/' + tc.productId + '.json?shop=' + encodeURIComponent(shop) + '&v=' + (tc.version || '');
    return fetch(url, { credentials: 'omit' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }
  function aktiveVariante() {
    var c = S.camp; if (!c) return null;
    var alle = [];
    (c.campaign_products || []).forEach(function (cp) { (cp.campaign_variants || []).forEach(function (v) { alle.push({ cv: v, cp: cp }); }); });
    var sid = null;
    try { sid = new URLSearchParams(location.search).get('variant'); } catch (e) {}
    if (sid) {
      var iv = (c.instance_variants || []).filter(function (x) { return String(x.platform_linked_id) === String(sid); })[0];
      if (iv) { var t = alle.filter(function (x) { return x.cv.variant_id === iv.variant_id; })[0]; if (t) return t; }
    }
    // Rückfall: gewählte teeinblue-Radios (Wert = Größen-/Farbname der Variante)
    var werte = $$('.tee-campaign input[type=radio]:checked, .teeinblue-item input[type=radio]:checked').map(function (i) { return i.value; });
    var treffer = alle.filter(function (x) { return werte.indexOf(x.cv.size) > -1 && (werte.indexOf(x.cv.color) > -1 || !x.cv.color || x.cv.color === 'Default'); });
    return treffer[0] || alle[0] || null;
  }
  function druckflaecheVon(v) {
    if (!v) return null;
    var ids = (v.cv.variant && v.cv.variant.printarea_ids) || [];
    var pas = (v.cp.product && v.cp.product.printareas) || [];
    var pa = pas.filter(function (p) { return ids.indexOf(p.id) > -1; })[0] || pas[0] || null;
    if (!pa) return null;
    var pl = (S.camp.campaign_artworks || []).filter(function (a) { return a.printarea_id === pa.id; })
      .sort(function (a, b) { return (b.id || 0) - (a.id || 0); })[0] || null;   // teeinblue zeichnet die jüngste Zuordnung
    return { pa: pa, platz: pl };
  }

  /* ---------------- Druckinhalt als SVG (identisch zur Druckdatei-Geometrie) ---------------- */
  // Legt die Druckfläche (0..PW, 0..PH) mit dem Artwork an seiner Platzierung in <g>.
  function druckInhalt(g, ox, oy, mitWeiss) {
    var pa = S.pa, pl = S.platz, vb = S.artVB;
    if (mitWeiss) g.appendChild(sv('rect', { x: ox, y: oy, width: pa.width, height: pa.height, fill: '#fff' }));
    if (!pl || !vb) return;
    var r = +pl.rotate || 0;
    // teeinblue verzerrt nie: weicht die Platzierungsbox vom Artwork-Verhältnis ab, wird mittig eingepasst (#2913)
    var inner = sv('svg', { x: ox + pl.left, y: oy + pl.top, width: pl.width, height: pl.height, viewBox: vb.join(' '), preserveAspectRatio: 'xMidYMid meet', overflow: 'visible' });
    var u = sv('use', { href: '#tee-artwork-' + S.artId, width: vb[2], height: vb[3] });
    u.setAttributeNS(XL, 'xlink:href', '#tee-artwork-' + S.artId);
    inner.appendChild(u);
    if (r) {
      var gg = sv('g', { transform: 'rotate(' + r + ' ' + (ox + pl.left + pl.width / 2) + ' ' + (oy + pl.top + pl.height / 2) + ')' });
      gg.appendChild(inner); g.appendChild(gg);
    } else g.appendChild(inner);
  }
  /* Liegt das Motiv gedreht in der Druckfläche (Hochformat-Decke: Druckdatei quer, Motiv rotate 270), zeigt die
     Raumansicht und das Druckbild es AUFRECHT – nur die Darstellung dreht, der Druckinhalt bleibt unverändert. */
  function lage() {
    var pa = S.pa, pl = S.platz; if (!pa) return { w: 1, h: 1, r: 0 };
    var r = (((+(pl && pl.rotate) || 0) % 360) + 360) % 360;
    if ((r === 90 || r === 270) && !(S.bp && S.bp.verfahren === 'zylinder')) return { w: pa.height, h: pa.width, r: r };
    return { w: pa.width, h: pa.height, r: 0 };
  }
  function druckAufrecht(g, ox, oy, mitWeiss) {
    var L = lage(); if (!L.r) return druckInhalt(g, ox, oy, mitWeiss);
    var t = L.r === 270 ? 'translate(' + (ox + L.w) + ',' + oy + ') rotate(90)' : 'translate(' + ox + ',' + (oy + L.h) + ') rotate(-90)';
    var gg = sv('g', { transform: t }); druckInhalt(gg, 0, 0, mitWeiss); g.appendChild(gg);
  }
  /* Ein Kundenfoto an mehreren Stellen (globale teeinblue-Vorlage, z. B. Hundenapf 1-2-3-1-2-3): teeinblue zeigt je
     Stelle ein eigenes, gleich verknüpftes Formularfeld – nur das erste bleibt sichtbar (reines CSS, kein Eingriff in teeinblues DOM). */
  function doppelteFelder() {
    var n = {}, regeln = [];
    $$('#teeFormInputs .tee-field').forEach(function (f) { var m = (f.className.match(/tee-field--(layer-\d+)/) || [])[1]; if (m) n[m] = (n[m] || 0) + 1; });
    Object.keys(n).forEach(function (id) { if (n[id] > 1) regeln.push('#teeFormInputs .tee-field--' + id + ' ~ .tee-field--' + id + '{display:none!important}'); });
    var css = regeln.join('\n'), st = D.getElementById('lr-vf-doppelt');
    if (!css) { if (st) st.textContent = ''; return; }
    if (!st) { st = D.createElement('style'); st.id = 'lr-vf-doppelt'; D.head.appendChild(st); }
    if (st.textContent !== css) st.textContent = css;
  }
  function abdeckung() {
    var pa = S.pa, pl = S.platz; if (!pa || !pl) return null;
    var r = (+pl.rotate || 0) % 180 !== 0;
    var bw = pl.width, bh = pl.height, ar = S.artVB ? S.artVB[2] / S.artVB[3] : bw / bh;
    if (bw / bh > ar) bw = bh * ar; else bh = bw / ar;          // eingepasst wie teeinblue
    var w = r ? bh : bw, h = r ? bw : bh;
    var cx = pl.left + pl.width / 2, cy = pl.top + pl.height / 2;
    var x0 = Math.max(0, cx - w / 2), x1 = Math.min(pa.width, cx + w / 2), y0 = Math.max(0, cy - h / 2), y1 = Math.min(pa.height, cy + h / 2);
    var f = Math.max(0, x1 - x0) * Math.max(0, y1 - y0) / (pa.width * pa.height);
    var beschnitt = 1 - (Math.max(0, x1 - x0) * Math.max(0, y1 - y0)) / (w * h);
    return { anteil: f, beschnitt: beschnitt };
  }

  /* ---------------- Gerüst ---------------- */
  function geruest() {
    var media = $('.product-information__media'); if (!media) return false;
    if (S.el.wurzel && S.el.wurzel.isConnected) return true;
    var w = mk('div', 'lr-vf');
    w.setAttribute('aria-label', 'Vorschau deines Geschenks');
    w.innerHTML =
      '<div class="lr-vf-sicht"><div class="lr-vf-buehne"></div><div class="lr-vf-flach" hidden></div></div>' +
      '<div class="lr-vf-leiste" role="group" aria-label="Ansicht">' +
        '<button type="button" data-lr-vf="echt" aria-pressed="true">Ansicht</button>' +
        '<button type="button" data-lr-vf="druck" aria-pressed="false">Druckbild</button>' +
        '<button type="button" data-lr-vf="lupe" aria-pressed="false" aria-label="Lupe">Lupe</button>' +
      '</div>' +
      '<p class="lr-vf-tipp" hidden></p>' +
      '<p class="lr-vf-info" hidden></p>' +
      '<p class="lr-vf-dev" hidden></p>';
    media.appendChild(w);    // am Ende: andere Skripte, die das erste Bild der Galerie suchen, bleiben unberührt
    S.el.wurzel = w; S.el.media = media;
    S.el.sicht = $('.lr-vf-sicht', w); S.el.buehne = $('.lr-vf-buehne', w); S.el.flach = $('.lr-vf-flach', w);
    S.el.tipp = $('.lr-vf-tipp', w); S.el.info = $('.lr-vf-info', w); S.el.dev = $('.lr-vf-dev', w);
    $('.lr-vf-leiste', w).addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      var a = b.getAttribute('data-lr-vf');
      if (a === 'lupe') {
        S.lupe = !S.lupe; S.el.wurzel.classList.toggle('lr-vf-lupe', S.lupe); b.setAttribute('aria-pressed', String(S.lupe)); b.textContent = S.lupe ? 'Zurück' : 'Lupe';
        if (S.lupe && S.bildGroesse < 1600) { S.bildGroesse = 1600; umbauen(); } else layout();
        if (S.lupe) requestAnimationFrame(function () { var v = S.el.sicht; v.scrollLeft = (v.scrollWidth - v.clientWidth) / 2; v.scrollTop = (v.scrollHeight - v.clientHeight) / 2; });
        tippZeigen(); return;
      }
      S.modus = a; zeigeModus();
    });
    if (W.ResizeObserver) new ResizeObserver(function () { planLayout(); }).observe(media);
    W.addEventListener('resize', planLayout, { passive: true });
    return true;
  }
  function zeigtDruck() { return S.modus === 'druck' || !S.bp || S.bp.verfahren === 'druck'; }
  function zeigeModus() {
    var druck = zeigtDruck();
    if (S.el.info && S.infoArt === 'leer') S.el.info.hidden = druck || !S.el.info.textContent;
    S.el.flach.hidden = !druck; S.el.buehne.hidden = druck;
    $$('.lr-vf-leiste button', S.el.wurzel).forEach(function (b) {
      var a = b.getAttribute('data-lr-vf'); if (a === 'lupe') { b.hidden = druck; return; }
      b.setAttribute('aria-pressed', String(a === (druck ? 'druck' : 'echt')));
      if (a === 'echt') b.hidden = !S.bp || S.bp.verfahren === 'druck';
    });
    if (S.el.ansicht) { S.el.ansicht.hidden = druck || !S.el.ansicht.innerHTML; S.el.wurzel.classList.toggle('lr-vf-mit-ansicht', !S.el.ansicht.hidden); }
    tippZeigen();
    planLayout();
  }
  function tippZeigen() {
    var t = S.el.tipp; if (!t) return;
    var zeigen = S.modus === 'echt' && S.bp && S.bp.verfahren === 'zylinder' && S.bp.drehbar !== false && !S.bp.ohne_druck && !S.lupe;
    t.hidden = !zeigen; if (zeigen) t.textContent = 'Zum Drehen wischen';
  }

  /* ---------------- Ansichten (zwei echte Fotos: Henkel links/rechts, Zaubertasse heiß/kalt) ---------------- */
  function seiteFuer(roh, pa) {
    var n = String((pa && (pa.display_name || pa.name)) || '');
    var r = (roh.ansicht_regeln || []).filter(function (x) { return n.indexOf(x[0]) > -1; })[0];
    if (r && roh.ansichten[r[1]]) return r[1];
    return Object.keys(roh.ansichten).filter(function (k) { return !/^kalt-/.test(k); })[0];
  }
  function gedreht(pl) { var r = (((+(pl && pl.rotate) || 0) % 360) + 360) % 360; return r === 90 || r === 270; }
  function ansichtWaehlen(roh, pa, pl) {
    if (roh.ansichten.hoch && roh.ansichten.quer) return gedreht(pl) ? 'hoch' : 'quer';    // Decke/Handtuch/Wandteppich
    var a = roh.ansichten, seite = S.seiteManuell && a[S.seiteManuell] ? S.seiteManuell : seiteFuer(roh, pa);
    return S.kalt && a['kalt-' + seite] ? 'kalt-' + seite : seite;
  }
  function ansichtKnoepfe(roh, key) {
    var box = S.el.ansicht;
    if (!box) {
      box = S.el.ansicht = mk('div', 'lr-vf-ansicht'); box.setAttribute('role', 'group'); box.setAttribute('aria-label', 'Ansicht wählen');
      S.el.wurzel.appendChild(box);
      box.addEventListener('click', function (e) {
        var b = e.target.closest('button'); if (!b) return;
        if (b.hasAttribute('data-seite')) S.seiteManuell = b.getAttribute('data-seite');
        if (b.hasAttribute('data-kalt')) S.kalt = !S.kalt;
        umbauen();
      });
    }
    var a = roh && roh.ansichten, h = '';
    if (a) {
      var seite = String(key || '').replace(/^kalt-/, ''), kalt = /^kalt-/.test(key || '');
      if (a.links && a.rechts) {
        h += '<button type="button" data-seite="links" aria-pressed="' + (seite === 'links') + '">Henkel links</button>';
        h += '<button type="button" data-seite="rechts" aria-pressed="' + (seite === 'rechts') + '">Henkel rechts</button>';
      }
      if (a['kalt-links'] || a['kalt-rechts']) h += '<button type="button" data-kalt="1" aria-pressed="' + kalt + '">' + (kalt ? 'Heiß ansehen' : 'Kalt ansehen') + '</button>';
    }
    if (box.getAttribute('data-h') !== h) { box.innerHTML = h; box.setAttribute('data-h', h); }
    box.hidden = !h || zeigtDruck();
    S.el.wurzel.classList.toggle('lr-vf-mit-ansicht', !box.hidden);
  }

  /* ---------------- Aufbau je Variante ---------------- */
  var bauLauf = null;
  function umbauen() {
    var token = ++S.token;
    var v = aktiveVariante(); if (!v) return;
    var dp = druckflaecheVon(v); if (!dp) return;
    var basisId = String(v.cp.product_id);
    var prod = (PARAM.produkte || {})[String(S.pid)] || {};
    if (S.variante && S.variante.cv.variant_id !== v.cv.variant_id) S.seiteManuell = null;   // neues Format: passende Seite
    var bpRoh = (PARAM.basen || {})[prod.basis || basisId] || null;
    if (bpRoh && prod.naeherung && !NAEHERUNG) bpRoh = null;          // Näherung nur mit eigenem Schalter
    if (bpRoh && prod.verfahren === 'druck') bpRoh = null;
    var ansKey = bpRoh && bpRoh.ansichten ? ansichtWaehlen(bpRoh, dp.pa, dp.platz) : null;
    var bp = ansKey ? Object.assign({}, bpRoh, bpRoh.ansichten[ansKey], { ansichten: null }) : bpRoh;
    var artId = dp.platz ? dp.platz.artwork_id : null;
    var svgA = artId ? artworkSvg(artId) : null;
    if (!svgA) { var alle = $$('svg[id^="tee-artwork-"]'); svgA = alle[0] || null; if (svgA) artId = svgA.id.replace('tee-artwork-', ''); }
    if (!svgA) return;
    var vbAttr = (svgA.getAttribute('viewBox') || '').split(/[\s,]+/).map(Number);
    if (vbAttr.length !== 4 || !vbAttr[2]) vbAttr = [0, 0, svgA.width.baseVal.value || 500, svgA.height.baseVal.value || 500];
    var neu = { v: v, pa: dp.pa, platz: dp.platz, artId: artId, artVB: vbAttr, bp: bp ? Object.assign({}, bp, { id: (prod.basis || basisId) + (ansKey ? ':' + ansKey : '') }) : { verfahren: 'druck' }, prod: prod, roh: bpRoh, ans: ansKey };
    // Bilder der neuen Variante vorladen – erst tauschen, wenn alles da ist (kein Flackern)
    var urls = [];
    if (neu.bp.verfahren !== 'druck') {
      (neu.bp.ebenen || []).forEach(function (e) { urls.push(bildUrl(neu.bp.bild + '-' + e, e === 'maske' || e === 'henkel' ? 'png' : null)); });
      // Nachbar-Ansichten im Hintergrund vorwärmen (Wechsel Henkel/heiß-kalt ohne Wartezeit)
      if (neu.roh && neu.roh.ansichten) setTimeout(function () { Object.keys(neu.roh.ansichten).forEach(function (k) { var a = neu.roh.ansichten[k]; (a.ebenen || []).forEach(function (e) { ladeBild(bildUrl(a.bild + '-' + e, e === 'maske' ? 'png' : null)); }); }); }, 1200);
    }
    bauLauf = Promise.all(urls.map(ladeBild)).then(function (bilder) {
      if (token !== S.token) return;                            // ein neuerer Wechsel hat übernommen
      var altVar = S.variante && S.variante.cv.variant_id;
      S.variante = neu.v; S.pa = neu.pa; S.platz = neu.platz; S.artId = neu.artId; S.artVB = neu.artVB; S.bp = neu.bp; S.prod = neu.prod; S.ansicht = neu.ans;
      S.bilder = {}; (neu.bp.ebenen || []).forEach(function (e, i) { S.bilder[e] = bilder[i] ? bilder[i].src : bildUrl(neu.bp.bild + '-' + e); });
      S.el.wurzel.setAttribute('data-verfahren', neu.bp.verfahren);
      S.el.wurzel.setAttribute('data-druckflaeche', neu.pa.display_name || neu.pa.id);
      var gleich = S.el.bild && S.el.bild.isConnected && S.bauId === neu.bp.id && S.bauGroesse === S.bildGroesse && neu.bp.verfahren !== 'druck';
      if (gleich) auffrischen(); else bauen();   // gleiche Basis: nur Inhalt tauschen – kein Neuaufbau, kein Flackern
      S.bauId = neu.bp.id; S.bauGroesse = S.bildGroesse;
      flachBauen();
      if (neu.bp.verfahren === 'zylinder' && !neu.bp.ohne_druck) {
        var ziel = neu.bp.d != null ? neu.bp.d : standardDrehung();
        if (altVar == null || RUHIG || neu.bp.drehbar === false) { S.d = ziel; S.dZiel = ziel; zylZeichnen(); }
        else dreheZu(ziel);
      }
      ansichtKnoepfe(neu.roh, neu.ans);
      formateDeutsch();
      infoZeigen();
      devZeigen();
      zeigeModus();
      D.body.classList.add('lr-vf-an');
      S.el.wurzel.classList.add('lr-vf-bereit');
      qualitaetPruefen();
      if (altVar != null && altVar !== neu.v.cv.variant_id) setTimeout(function () { nachschneiden(neu.v.cv.variant_id, 0); }, 1500);
    });
  }

  /* teeinblue schneidet das Kundenfoto beim Hochladen auf das GERADE gewählte Format zu. Wechselt der Kunde danach
     das Format (z. B. Rundum 2,2:1 → Foto rechts hochkant 0,88:1), schneidet teeinblue aus dem schon beschnittenen
     Bild noch einmal die Mitte heraus – übrig bleiben ~40 % des Fotos (Lucas iPhone-Test 02.10.2026, auch im Druck).
     Abhilfe: passt das Kundenbild nicht mehr zur neuen Foto-Ebene, das gemerkte Original erneut hochladen –
     teeinblue öffnet dann seinen Zuschnitt im neuen Format. */
  function kundenbild() {
    var a = artworkSvg(S.artId); if (!a) return null;
    var im = [].slice.call(a.querySelectorAll('image')).filter(function (i) { return /\/customers\//.test(i.getAttribute('href') || i.getAttribute('xlink:href') || ''); })[0];
    return im || null;
  }
  function nachschneiden(varId, versuch) {
    if (!S.fotoDatei || !S.variante || S.variante.cv.variant_id !== varId) return;
    var im = kundenbild(); if (!im) { if (versuch < 6) setTimeout(function () { nachschneiden(varId, versuch + 1); }, 700); return; }
    var href = im.getAttribute('href') || im.getAttribute('xlink:href');
    var feld = (+im.getAttribute('width')) / (+im.getAttribute('height'));
    var I = new Image();
    I.onload = function () {
      var bild = I.naturalWidth / I.naturalHeight;
      var ziel = fotoEbeneVerhaeltnis() || feld;
      if (!ziel || !bild || Math.abs(bild / ziel - 1) < 0.03) return;               // passt – nichts tun
      if (S.nachgeschnitten === varId) return;                                       // pro Format nur einmal
      if (S.nachgeschnitten === varId) return;
      S.nachgeschnitten = varId;
      // teeinblues Zuschnitt-Dialog behält auf der laufenden Seite das Verhältnis des ersten Öffnens (gemessen
      // 02.10.2026, auch nach Schließen/neuem Upload). Sicher ist nur: Seite mit dem neuen Format frisch laden und
      // das gemerkte Originalfoto dort automatisch einsetzen – dann öffnet der Zuschnitt im richtigen Verhältnis.
      var shopVar = shopifyVariante(varId); if (!shopVar) return;
      merkeFoto({ pid: String(S.pid), buf: S.fotoDatei.buf, name: S.fotoDatei.name, type: S.fotoDatei.type, zeit: Date.now() }).then(function () {
        hinweis('Neues Format – wir setzen dein Foto passend ein …');
        var u = new URL(location.href); u.searchParams.set('variant', shopVar); u.hash = 'gestalten';
        // Gleiche Adresse (teeinblue schreibt die Variante schon in die URL) lädt per replace() nicht neu → reload()
        setTimeout(function () { try { history.replaceState(history.state, '', u.toString()); } catch (e) {} location.reload(); }, 400);
      }).catch(function () {});
    };
    I.src = href;
  }
  function fotoEbeneVerhaeltnis() {
    var a = (S.camp && S.camp.artworks || []).filter(function (x) { return String(x.id) === String(S.artId); })[0]; if (!a) return null;
    var L = null; (a.data || []).some(function (tp) { return (tp.layers || []).some(function (l) { if (l.type === 'photo') { L = l; return true; } return false; }); });
    return L && L.width && L.height ? L.width / L.height : null;
  }
  function shopifyVariante(varId) {
    var iv = (S.camp && S.camp.instance_variants || []).filter(function (x) { return x.variant_id === varId; })[0];
    return iv && iv.platform_linked_id ? String(iv.platform_linked_id) : null;
  }
  function db() {
    return new Promise(function (ok, nein) {
      if (!W.indexedDB) return nein();
      var r = indexedDB.open('lr-vf', 1);
      r.onupgradeneeded = function () { r.result.createObjectStore('foto'); };
      r.onsuccess = function () { ok(r.result); }; r.onerror = function () { nein(r.error); };
    });
  }
  function merkeFoto(d) {
    return db().then(function (x) { return new Promise(function (ok, nein) { var tx = x.transaction('foto', 'readwrite'); tx.objectStore('foto').put(d, 'neu'); tx.oncomplete = ok; tx.onerror = nein; }); });
  }
  function holeFoto() {
    return db().then(function (x) { return new Promise(function (ok) {
      var tx = x.transaction('foto', 'readwrite'), st = tx.objectStore('foto'), g = st.get('neu');
      g.onsuccess = function () { st.delete('neu'); ok(g.result || null); }; g.onerror = function () { ok(null); };
    }); }).catch(function () { return null; });
  }
  // Nach dem Neuladen: gemerktes Originalfoto einsetzen (nur gleiches Produkt, höchstens 3 Minuten alt)
  function fotoWiederEinsetzen() {
    holeFoto().then(function (d) {
      if (!d || d.pid !== String(S.pid) || Date.now() - d.zeit > 180000) return;
      S.fotoDatei = { buf: d.buf, name: d.name, type: d.type };
      var n = 0;
      (function warte() {
        var inp = $$('.tee-campaign input[type=file], .teeinblue-item input[type=file]')[0];
        if (!inp || !teeFeld()) { if (++n < 40) setTimeout(warte, 300); return; }
        try {
          var dt = new DataTransfer();
          dt.items.add(new File([d.buf], d.name || 'foto.jpg', { type: d.type || 'image/jpeg' }));
          S.eigenerUpload = true; S.nachgeschnitten = S.variante && S.variante.cv.variant_id;
          inp.files = dt.files; inp.dispatchEvent(new Event('change', { bubbles: true }));
          hinweis('Bitte wähle den Bildausschnitt für das neue Format.');
        } catch (e) { S.eigenerUpload = false; }
      })();
    });
  }
  function teeFeld() {
    try {
      var w = D.getElementById('teeinblue-wrapper'); var gefunden = null;
      (function lauf(v, d) {
        if (gefunden || !v || d > 80) return;
        var k = v.component;
        if (k) { var nm = k.type && (k.type.name || k.type.__name); if (nm === 'ImageCropper' && k.props && k.props.field) { gefunden = k.props.field; return; } if (k.subTree) lauf(k.subTree, d + 1); }
        (Array.isArray(v.children) ? v.children : []).forEach(function (x) { lauf(x, d + 1); });
        (v.dynamicChildren || []).forEach(function (x) { lauf(x, d + 1); });
      })(w && w._vnode, 0);
      return gefunden && gefunden.width ? { width: gefunden.width, height: gefunden.height } : null;
    } catch (e) { return null; }
  }
  function hinweis(text) {
    var i = S.el.info; if (!i) return;
    i.textContent = text; i.hidden = false; S.infoArt = 'hinweis';
    clearTimeout(S.hinweisT); S.hinweisT = setTimeout(function () { if (S.infoArt === 'hinweis') { i.hidden = true; S.infoArt = null; infoZeigen(); } }, 6000);
  }

  function bauen() {
    var b = S.el.buehne; b.innerHTML = ''; S.strips = []; S.zellen = []; S.weissK = null; S.el.weiss = null;   // neue Weiß-Fläche braucht ihren Umriss
    var bp = S.bp; if (!bp || bp.verfahren === 'druck') return;
    b.style.background = bp.grund || '#EEE9E3';
    var bild = mk('div', 'lr-vf-bild'); b.appendChild(bild); S.el.bild = bild;
    var anp = mk('div', 'lr-vf-anp'); bild.appendChild(anp); S.el.anp = anp;
    function img(cls, src, extra) { var i = mk('img', 'lr-vf-e ' + cls); i.alt = ''; i.decoding = 'async'; i.draggable = false; i.src = src; if (extra) extra(i); anp.appendChild(i); return i; }
    if (bp.ohne_druck) {                       // z. B. Zaubertasse kalt: nur das Foto, Motiv unsichtbar
      S.el.grund = img('lr-vf-grund', S.bilder.basis);
      layout(); return;
    }
    if (bp.verfahren === 'zylinder') {
      S.el.grund = img('lr-vf-grund', S.bilder.ohne || S.bilder.basis);
      if (S.bilder.henkel) S.el.hHinten = img('lr-vf-henkel', S.bilder.henkel); else S.el.hHinten = S.el.hVorn = null;
      // Weiße Keramik unter den Streifen (eine Fläche statt je Streifen: WebKit ließ an jeder Streifenkante
      // einen Haarstrich des Streifen-Hintergrunds stehen)
      S.el.weiss = mk('div', 'lr-vf-weiss'); anp.appendChild(S.el.weiss);
      var st = mk('div', 'lr-vf-streifen'); anp.appendChild(st); S.el.streifen = st;
      var n = (bp.zyl && bp.zyl.streifen) || 64;
      for (var i = 0; i < n; i++) {
        var d = mk('div', 'lr-vf-st');
        var s = sv('svg', { preserveAspectRatio: 'none' });
        var g = sv('g', {});
        s.appendChild(g); d.appendChild(s); st.appendChild(d);
        S.strips.push({ el: d, svg: s, g: g });
      }
      zylInhalt();
      S.el.licht = img('lr-vf-licht', S.bilder.licht);
      if (S.bilder.glanz) S.el.glanz = img('lr-vf-glanz', S.bilder.glanz);
      if (S.bilder.henkel) S.el.hVorn = img('lr-vf-henkel', S.bilder.henkel);
      if (S.bilder.vorne) img('lr-vf-vorne', S.bilder.vorne);
      if (bp.drehbar !== false) drehSteuerung();
    } else {
      S.el.grund = img('lr-vf-grund', S.bilder.basis);
      var nx = (bp.netz && bp.netz[0]) || 1, ny = (bp.netz && bp.netz[1]) || 1;
      if (nx * ny > 1) { S.el.weiss = mk('div', 'lr-vf-weiss'); anp.appendChild(S.el.weiss); }
      var netz = mk('div', 'lr-vf-netz'); anp.appendChild(netz); S.el.netz = netz;
      for (var j = 0; j < ny; j++) for (var i2 = 0; i2 < nx; i2++) {
        var z = mk('div', 'lr-vf-zelle');
        var s2 = sv('svg', { preserveAspectRatio: 'none' });
        var g2 = sv('g', {}); druckAufrecht(g2, 0, 0, nx * ny === 1);
        s2.appendChild(g2); z.appendChild(s2); netz.appendChild(z);
        S.zellen.push({ el: z, svg: s2, i: i2, j: j, nx: nx, ny: ny });
      }
      if (S.bilder.maske) {
        // Form des Produkts (Lätzchen, Herz, Decke am Sessel): Motiv UND weiße Unterfläche nur innerhalb der Form
        [netz, S.el.weiss].forEach(function (e) {
          if (!e) return;
          e.style.webkitMaskImage = e.style.maskImage = 'url("' + S.bilder.maske + '")';
          e.classList.add('lr-vf-maskiert');
        });
      }
      if (bp.raster) rasterEbene();
      S.el.licht = img('lr-vf-licht', S.bilder.licht);
      if (S.bilder.glanz) S.el.glanz = img('lr-vf-glanz', S.bilder.glanz);
      if (S.bilder.vorne) img('lr-vf-vorne', S.bilder.vorne);
    }
    layout();
  }

  function auffrischen() {
    if (S.bp.ohne_druck) return layout();
    if (S.bp.verfahren === 'zylinder') zylInhalt();
    else S.zellen.forEach(function (z) {
      var g = z.svg.firstChild; while (g.firstChild) g.removeChild(g.firstChild);
      druckAufrecht(g, 0, 0, S.zellen.length === 1);
    });
    layout();
  }

  /* ---------------- Layout (Größe der Bühne, Skalierung) ---------------- */
  var layoutGeplant = 0;
  function planLayout() { if (layoutGeplant) return; layoutGeplant = requestAnimationFrame(function () { layoutGeplant = 0; layout(); }); }
  function layout() {
    var bp = S.bp, w = S.el.wurzel; if (!w) return;
    var r = S.el.sicht.getBoundingClientRect();
    if (!r.width || !r.height) return;
    // Bildgröße nach Gerät: 1100 px (Handy) oder 1600 px (Desktop/Lupe)
    var bedarf = r.width * (W.devicePixelRatio || 1) * (S.lupe ? 2 : 1);
    var stufe = bedarf > 1250 ? 1600 : 1100;
    if (stufe > S.bildGroesse) { S.bildGroesse = stufe; return umbauen(); }
    if (bp && bp.verfahren !== 'druck') {
      var a = (bp.ausschnitt || [0, 0, bp.bildB, bp.bildH]).slice();
      S.fx = fxBerechnen();
      if (S.fx > 1 && bp.anpassen) {            // breiter gestrecktes Produkt: Ausschnitt mitwachsen lassen
        var mx = bp.anpassen.cx, hw = Math.max(mx - a[0], a[2] - mx) * S.fx;
        a[0] = mx - hw; a[2] = mx + hw;
      }
      S.aus = a;
      var aw = a[2] - a[0], ah = a[3] - a[1];
      var f = S.lupe ? 2 : 1;
      var k = Math.min(r.width / aw, r.height / ah) * f;
      S.k = k;
      var bw = aw * k, bh = ah * k;
      var b = S.el.buehne;
      b.style.width = Math.round(bw) + 'px'; b.style.height = Math.round(bh) + 'px';
      b.style.marginLeft = S.lupe ? '0' : Math.max(0, Math.round((r.width - bw) / 2)) + 'px';
      b.style.marginTop = S.lupe ? '0' : Math.max(0, Math.round((r.height - bh) / 2)) + 'px';
      var bild = S.el.bild;
      bild.style.width = Math.round(bp.bildB * k) + 'px'; bild.style.height = Math.round(bp.bildH * k) + 'px';
      bild.style.transform = 'translate(' + (-a[0] * k).toFixed(2) + 'px,' + (-a[1] * k).toFixed(2) + 'px)';
      $$('.lr-vf-e', bild).forEach(function (i) {
        if (i.classList.contains('lr-vf-henkel')) return;
        i.style.width = (bp.bildB * k) + 'px'; i.style.height = (bp.bildH * k) + 'px';
      });
      anpassen();
      if (bp.verfahren === 'zylinder') zylZeichnen(); else netzZeichnen();
      // Decken maßstäblich: kleinere Größen erscheinen kleiner als die größte (Lucas iPhone-Test 02.10.2026)
      var m = S.lupe ? null : massstab();
      b.style.transformOrigin = '50% 55%';
      b.style.transform = m && m.f < 0.999 ? 'scale(' + m.f.toFixed(3) + ')' : '';
      massZeigen(m);
    }
    flachLayout();
  }
  function cmVon(s) { var m = String(s || '').match(/(\d{2,3})\s*[x×]\s*(\d{2,3})/); return m ? [+m[1], +m[2]] : null; }
  function massstab() {
    if (!S.bp || !(S.bp.massstab || S.bp.bild === 'decke') || !S.variante || !S.camp) return null;
    var jetzt = cmVon(S.variante.cv.size) || cmVon(S.pa && (S.pa.display_name || S.pa.name)); if (!jetzt) return null;
    var maxB = 0;
    (S.camp.campaign_products || []).forEach(function (cp) { (cp.campaign_variants || []).forEach(function (v) { var c = cmVon(v.size); if (c) maxB = Math.max(maxB, Math.max(c[0], c[1])); }); });
    if (!maxB) return null;
    var f = Math.max(0.4, Math.max(jetzt[0], jetzt[1]) / maxB);
    if (S.bp.massstab === 'text') f = 1;          // echtes Raumfoto (Decke am Sessel, Wandteppich): Größe nur als Zeile
    return { f: f, cm: jetzt, maxB: maxB };
  }
  function massZeigen(m) {
    var e = S.el.mass;
    if (!e) { e = S.el.mass = mk('p', 'lr-vf-mass'); S.el.wurzel.insertBefore(e, S.el.tipp); }
    e.hidden = !m;
    var cm = m ? (S.hoch ? m.cm.slice().sort(function (x, y) { return x - y; }) : m.cm) : null;
    if (m) e.textContent = cm[0] + ' × ' + cm[1] + ' cm' + (m.f < 0.999 ? ' · maßstäblich zur größten Größe (' + m.maxB + ' cm)' : '');
  }

  /* ---------------- Seitenverhältnis-Anpassung (Decke/Puzzle/Mauspad) ---------------- */
  function fxBerechnen() {
    var bp = S.bp; if (!bp || !bp.anpassen || !S.pa) return 1;
    var L0 = lage(), f = (L0.w / L0.h) / bp.anpassen.foto;
    var mx = bp.anpassen.max || 1.28;
    return (Math.abs(f - 1) > 0.004 && f > 1 / mx && f < mx) ? f : 1;
  }
  function anpassen() {
    var bp = S.bp, anp = S.el.anp; if (!anp) return;
    var cx = (bp.anpassen ? bp.anpassen.cx : 0) * S.k;
    anp.style.transformOrigin = cx + 'px 0';
    anp.style.transform = S.fx !== 1 ? 'scaleX(' + S.fx.toFixed(5) + ')' : '';
    [S.el.netz, S.el.weiss].forEach(function (e) {
      if (e && e.classList.contains('lr-vf-maskiert')) e.style.webkitMaskSize = e.style.maskSize = (bp.bildB * S.k) + 'px ' + (bp.bildH * S.k) + 'px';
    });
  }

  /* ---------------- Zylinder (Tassen) ---------------- */
  // Abwicklung: Umfang C (in Druckpixeln), Höhe H. Winkel α ab Henkel, gegen den Uhrzeigersinn von oben
  // (= von außen gesehen läuft das Motiv links→rechts). Kamera sieht den Punkt α = d.
  function zylMasse() {
    var p = S.bp.physik; var dpi = p.dpi || 300;
    return { C: p.umfang_cm / 2.54 * dpi, H: p.hoehe_cm / 2.54 * dpi };
  }
  function flaechenMitte() {
    var f = (S.bp.flaechen || {})[String(S.pa.id)] || {};
    if (f.mitte == null) {
      var n = String(S.pa.display_name || S.pa.name || '');
      (S.bp.flaechen_muster || []).some(function (m) { if (n.indexOf(m[0]) > -1) { f = { mitte: m[1] }; return true; } return false; });
    }
    return { mitte: f.mitte != null ? f.mitte : (S.bp.standard_mitte || 180), v: f.v != null ? f.v : 0.5 };
  }
  function standardDrehung() {
    var m = flaechenMitte().mitte;
    // Henkel genau hinter der Tasse? Dann 45° weiter, damit man sieht, dass es eine Tasse ist
    var psi = rad(0 - m);
    if (!S.bp.ohne_henkel && Math.cos(psi) < -0.9) return m + 45;     // Napf/Leckerli-Glas: Motivmitte genau vorn
    return m;
  }
  function zylInhalt() {
    var M = zylMasse(), fm = flaechenMitte();
    var PW = S.pa.width, PH = S.pa.height;
    var x = (fm.mitte / 360) * M.C - PW / 2; x = ((x % M.C) + M.C) % M.C;
    var y = fm.v * M.H - PH / 2;
    S.zylX = x; S.zylY = y; S.zylC = M.C; S.zylH = M.H;
    S.strips.forEach(function (st) {
      var g = st.g; while (g.firstChild) g.removeChild(g.firstChild);
      [-M.C, 0, M.C].forEach(function (o) { druckInhalt(g, x + o, y, false); });
    });
  }
  function zylZeichnen() {
    var bp = S.bp, z = bp.zyl, k = S.k; if (!z || !S.strips.length) return;
    var t0 = performance.now();
    var n = S.strips.length, tmax = z.thetaMax || 88, dT = 2 * tmax / n;
    var C = S.zylC, H = S.zylH;
    // Streifen als 2D-Affinabbildung (kein matrix3d): Safari/WebKit rastet 3D-Ebenen auf ganze Pixel und
    // zeigt dann Haarlinien zwischen den Streifen. Fehler der Affin-Näherung: < 1 Bildschirmpixel am Rand.
    var hPx = (z.unten_y - z.oben_y) * k;
    if (S.el.weiss && S.weissK !== k) {
      var pts = [], m = 24;
      for (var q = 0; q <= m; q++) { var tq = -tmax + 2 * tmax * q / m; pts.push(((z.cx + z.r * Math.sin(rad(tq))) * k).toFixed(1) + 'px ' + ((z.oben_y + z.oben_b * Math.cos(rad(tq))) * k).toFixed(1) + 'px'); }
      for (var q2 = m; q2 >= 0; q2--) { var tq2 = -tmax + 2 * tmax * q2 / m; pts.push(((z.cx + z.r * Math.sin(rad(tq2))) * k).toFixed(1) + 'px ' + ((z.unten_y + z.unten_b * Math.cos(rad(tq2))) * k).toFixed(1) + 'px'); }
      S.el.weiss.style.clipPath = 'polygon(' + pts.join(',') + ')'; S.weissK = k;
    }
    for (var i = 0; i < n; i++) {
      var t1 = -tmax + i * dT;
      var cosM = Math.max(0.05, Math.cos(rad(t1 + dT)));
      var ovGrad = Math.min(dT * 0.6, Math.max(dT * 0.15, (1.6 / (z.r * k * cosM)) * 180 / Math.PI));   // ≥ 1,6 px Überlappung, aber gedeckelt
      /* nie über 89,5° hinaus: dahinter nimmt sin(θ) wieder ab, der Streifen würde gespiegelt und zeigte Motiv von der
         Rückseite (Lucas iPhone-Test 06.10.2026: Leckerli-Glas „rechts oben gerade abgeschnitten“) */
      var t2 = Math.min(t1 + dT + ovGrad, tmax + 0.4, 89.5);
      var a1 = S.d + t1;
      var u0 = ((a1 / 360) * C % C + C) % C, du = (t2 - t1) / 360 * C;
      var st = S.strips[i];
      var sw = Math.max(2, Math.ceil(Math.abs(Math.sin(rad(t2)) - Math.sin(rad(t1))) * z.r * k));
      var sh = Math.ceil(hPx);
      if (st.w !== sw || st.h !== sh) {
        st.el.style.width = sw + 'px'; st.el.style.height = sh + 'px';
        st.svg.setAttribute('width', sw); st.svg.setAttribute('height', sh);
        st.w = sw; st.h = sh;
      }
      st.svg.setAttribute('viewBox', u0.toFixed(3) + ' 0 ' + du.toFixed(3) + ' ' + H.toFixed(3));
      var x1 = (z.cx + z.r * Math.sin(rad(t1))) * k, x2 = (z.cx + z.r * Math.sin(rad(t2))) * k;
      var c1 = Math.cos(rad(t1)), c2 = Math.cos(rad(t2));
      var ol = [x1, (z.oben_y + z.oben_b * c1) * k], or_ = [x2, (z.oben_y + z.oben_b * c2) * k], ul = [x1, (z.unten_y + z.unten_b * c1) * k];
      st.el.style.transform = 'matrix(' + [(or_[0] - ol[0]) / sw, (or_[1] - ol[1]) / sw, (ul[0] - ol[0]) / sh, (ul[1] - ol[1]) / sh, ol[0], ol[1]].map(function (v) { return +v.toFixed(5); }).join(',') + ')';
    }
    henkelZeichnen();
    S.messung.push(performance.now() - t0); if (S.messung.length > 120) S.messung.shift();
  }
  function henkelZeichnen() {
    var bp = S.bp, h = bp.henkel, z = bp.zyl, k = S.k; if (!h || !S.el.hVorn) return;
    var psi = rad(0 - S.d);                 // Bildschirmwinkel des Henkels (0 = zur Kamera)
    var sn = Math.sin(psi), cs = Math.cos(psi);
    var ax = (z.cx + z.r * sn) * k;         // Ansatzlinie auf dem Schirm
    var dy = (h.b_mitte || 46) * (cs - 0) * k;   // Ellipsen-Versatz der Ansätze (Foto: cos = 0)
    var sx = Math.abs(sn) < 0.06 ? (sn < 0 ? -0.06 : 0.06) : sn;
    var tr = 'translate(' + (ax).toFixed(2) + 'px,' + (h.y * k + dy).toFixed(2) + 'px) scaleX(' + sx.toFixed(4) + ') translate(' + (-(h.ansatz - h.x) * k).toFixed(2) + 'px,0)';
    [S.el.hVorn, S.el.hHinten].forEach(function (e) {
      e.style.width = (h.b * k) + 'px'; e.style.height = (h.h * k) + 'px'; e.style.transform = tr;
    });
    var vorn = cs > 0.02;
    S.el.hVorn.style.visibility = vorn ? 'visible' : 'hidden';
    S.el.hHinten.style.visibility = vorn ? 'hidden' : 'visible';
  }
  var drehAnim = 0;
  function dreheZu(ziel) {
    cancelAnimationFrame(drehAnim);
    var start = S.d, diff = ((ziel - start + 540) % 360) - 180, t0 = performance.now(), dauer = 650;
    if (RUHIG || Math.abs(diff) < 0.5) { S.d = ziel; S.dZiel = ziel; zylZeichnen(); return; }
    (function schritt(t) {
      var p = Math.min(1, (t - t0) / dauer), e = 1 - Math.pow(1 - p, 3);
      S.d = start + diff * e; zylZeichnen();
      if (p < 1) drehAnim = requestAnimationFrame(schritt); else S.dZiel = S.d;
    })(t0);
  }
  var drehGebunden = false;
  function drehSteuerung() {
    if (drehGebunden) return; drehGebunden = true;
    var sicht = S.el.sicht, aktiv = false, x0 = 0, y0 = 0, d0 = 0, entschieden = false, quer = false, vx = 0, lt = 0, lx = 0;
    sicht.addEventListener('pointerdown', function (e) {
      if (!S.bp || S.bp.verfahren !== 'zylinder' || S.bp.drehbar === false || S.bp.ohne_druck || S.modus !== 'echt' || S.lupe) return;
      aktiv = true; entschieden = false; quer = false; x0 = lx = e.clientX; y0 = e.clientY; d0 = S.d; vx = 0; lt = performance.now();
      cancelAnimationFrame(drehAnim);
    });
    sicht.addEventListener('pointermove', function (e) {
      if (!aktiv) return;
      var dx = e.clientX - x0, dy = e.clientY - y0;
      if (!entschieden && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) { entschieden = true; quer = Math.abs(dx) > Math.abs(dy); if (quer) { try { sicht.setPointerCapture(e.pointerId); } catch (x) {} } }
      if (!quer) return;
      e.preventDefault();
      var t = performance.now(); vx = (e.clientX - lx) / Math.max(1, t - lt); lx = e.clientX; lt = t;
      // Winkel so, dass die Oberfläche unter dem Finger mitläuft
      S.d = d0 - dx / (S.bp.zyl.r * S.k) * 180 / Math.PI;
      if (!drehAnim) drehAnim = requestAnimationFrame(function () { drehAnim = 0; zylZeichnen(); });
      if (S.el.tipp) S.el.tipp.hidden = true;
    }, { passive: false });
    function ende() {
      if (!aktiv) return; aktiv = false;
      if (quer && !RUHIG && Math.abs(vx) > 0.25) {     // kurzes Nachlaufen
        var v = -vx / (S.bp.zyl.r * S.k) * 180 / Math.PI * 16;
        (function lauf() { v *= 0.9; S.d += v; zylZeichnen(); if (Math.abs(v) > 0.05) drehAnim = requestAnimationFrame(lauf); else drehAnim = 0; })();
      }
    }
    sicht.addEventListener('pointerup', ende); sicht.addEventListener('pointercancel', ende);
  }

  /* ---------------- Fläche / Netz (Decke, Kissen, Puzzle, Anhänger) ---------------- */
  function netzPunkt(u, v) {
    var bp = S.bp, e = bp.ecken, m = bp.mitten;
    // Wölbung: Inhalt zum Rand hin gestaucht (Kissen); 0 = eben
    var w = bp.woelbung || 0;
    function ease(t) { return (1 - w) * t + w * (0.5 - 0.5 * Math.cos(Math.PI * t)); }
    u = ease(u); v = ease(v);
    function bez(p0, c, p1, t) { return [(1 - t) * (1 - t) * p0[0] + 2 * (1 - t) * t * c[0] + t * t * p1[0], (1 - t) * (1 - t) * p0[1] + 2 * (1 - t) * t * c[1] + t * t * p1[1]]; }
    function st(p0, mi, p1) { return [2 * mi[0] - (p0[0] + p1[0]) / 2, 2 * mi[1] - (p0[1] + p1[1]) / 2]; }
    var ol = e[0], or_ = e[1], ur = e[2], ul = e[3];
    if (!m) {   // bilinear (für ebene Vierecke genügt; Homographie je Zelle macht den Rest)
      return [(1 - v) * ((1 - u) * ol[0] + u * or_[0]) + v * ((1 - u) * ul[0] + u * ur[0]), (1 - v) * ((1 - u) * ol[1] + u * or_[1]) + v * ((1 - u) * ul[1] + u * ur[1])];
    }
    var top = bez(ol, st(ol, m[0], or_), or_, u), bot = bez(ul, st(ul, m[2], ur), ur, u);
    var lef = bez(ol, st(ol, m[3], ul), ul, v), rig = bez(or_, st(or_, m[1], ur), ur, v);
    var bl = [(1 - v) * ((1 - u) * ol[0] + u * or_[0]) + v * ((1 - u) * ul[0] + u * ur[0]), (1 - v) * ((1 - u) * ol[1] + u * or_[1]) + v * ((1 - u) * ul[1] + u * ur[1])];
    return [(1 - v) * top[0] + v * bot[0] + (1 - u) * lef[0] + u * rig[0] - bl[0], (1 - v) * top[1] + v * bot[1] + (1 - u) * lef[1] + u * rig[1] - bl[1]];
  }
  function netzZeichnen() {
    var L0 = lage(), k = S.k, PW = L0.w, PH = L0.h;
    var fl = S.bp.flaeche_anteil || null;      // optional: welcher Teil der Druckfläche sichtbar ist (z. B. Vorderseite)
    var sx0 = fl ? fl[0] * PW : 0, sy0 = fl ? fl[1] * PH : 0, sww = fl ? fl[2] * PW : PW, shh = fl ? fl[3] * PH : PH;
    var viele = S.zellen.length > 1;
    if (S.el.weiss) {
      var pts = [], m = 16, rand = [];
      for (var q = 0; q < m; q++) rand.push([q / m, 0]);
      for (q = 0; q < m; q++) rand.push([1, q / m]);
      for (q = m; q > 0; q--) rand.push([q / m, 1]);
      for (q = m; q > 0; q--) rand.push([0, q / m]);
      rand.forEach(function (uv) { var pp = netzPunkt(uv[0], uv[1]); pts.push((pp[0] * k).toFixed(1) + 'px ' + (pp[1] * k).toFixed(1) + 'px'); });
      S.el.weiss.style.clipPath = 'polygon(' + pts.join(',') + ')';
    }
    S.zellen.forEach(function (z) {
      var u0 = z.i / z.nx, u1 = (z.i + 1) / z.nx, v0 = z.j / z.ny, v1 = (z.j + 1) / z.ny;
      var ov = viele ? 0.35 / z.nx : 0;     // Überlappung gegen Nähte (Zelle darunter liegt unter der nächsten)
      var U1 = Math.min(1, u1 + ov), V1 = Math.min(1, v1 + ov * z.nx / z.ny);
      var p = [netzPunkt(u0, v0), netzPunkt(U1, v0), netzPunkt(U1, V1), netzPunkt(u0, V1)].map(function (q) { return [q[0] * k, q[1] * k]; });
      var scharf = viele ? 1 : 2;           // Schärfe-Regel nur für die matrix3d-Ebene
      var cw = Math.ceil(Math.max(4, Math.hypot(p[1][0] - p[0][0], p[1][1] - p[0][1])) * scharf), ch = Math.ceil(Math.max(4, Math.hypot(p[3][0] - p[0][0], p[3][1] - p[0][1])) * scharf);
      z.el.style.width = cw + 'px'; z.el.style.height = ch + 'px';
      z.svg.setAttribute('width', cw); z.svg.setAttribute('height', ch);
      z.svg.setAttribute('viewBox', [(sx0 + u0 * sww).toFixed(2), (sy0 + v0 * shh).toFixed(2), ((U1 - u0) * sww).toFixed(2), ((V1 - v0) * shh).toFixed(2)].join(' '));
      if (viele) {
        z.el.style.transform = 'matrix(' + [(p[1][0] - p[0][0]) / cw, (p[1][1] - p[0][1]) / cw, (p[3][0] - p[0][0]) / ch, (p[3][1] - p[0][1]) / ch, p[0][0], p[0][1]].map(function (v) { return +v.toFixed(5); }).join(',') + ')';
      } else {
        var m = homographie(cw, ch, p); if (m) z.el.style.transform = m;
      }
    });
    if (S.bp.radius && S.zellen.length === 1) {
      var z0 = S.zellen[0], rr = S.bp.radius / Math.hypot(S.bp.ecken[1][0] - S.bp.ecken[0][0], S.bp.ecken[1][1] - S.bp.ecken[0][1]);
      z0.el.style.borderRadius = (rr * 100).toFixed(3) + '% / ' + (rr * 100 * (PW / PH)).toFixed(3) + '%';
    }
    if (S.el.raster) rasterLayout();
  }
  /* Puzzle: Schnittlinien als Kachel in der Teilegröße der Variante (Foto zeigt 300 Teile) */
  function rasterEbene() {
    var r = mk('div', 'lr-vf-raster'); S.el.anp.appendChild(r); S.el.raster = r;
    r.style.backgroundImage = 'url("' + ASSET + 'lr-vf-puzzle-kachel-256.webp")';
  }
  function rasterLayout() {
    var bp = S.bp, r = S.el.raster, k = S.k, e = bp.ecken;
    var teile = teileDerVariante();
    var x0 = e[0][0] * k, y0 = e[0][1] * k, w = (e[1][0] - e[0][0]) * k, h = (e[3][1] - e[0][1]) * k;
    r.style.left = x0 + 'px'; r.style.top = y0 + 'px'; r.style.width = w + 'px'; r.style.height = h + 'px';
    var spalten = teile ? teile[0] : bp.raster.spalten, zeilen = teile ? teile[1] : bp.raster.zeilen;
    var zw = w / spalten * 4, zh = h / zeilen * 4;           // Kachel = 4 × 4 Teile
    r.style.backgroundSize = zw.toFixed(2) + 'px ' + zh.toFixed(2) + 'px';
    r.hidden = !!(teile && teile[0] === bp.raster.spalten && teile[1] === bp.raster.zeilen);   // 300 Teile: Foto zeigt die echten Linien
  }
  function teileDerVariante() {
    var t = (S.bp.raster && S.bp.raster.varianten) || {};
    return t[String(S.pa.id)] || null;
  }

  /* ---------------- Flache Druckansicht ---------------- */
  function flachBauen() {
    var f = S.el.flach; f.innerHTML = '';
    var pa = S.pa; if (!pa) return;
    var zyl = S.bp && S.bp.verfahren === 'zylinder';
    var wrap = mk('div', 'lr-vf-blatt'); f.appendChild(wrap); S.el.blatt = wrap;
    var PW = pa.width, PH = pa.height, ox = 0, gesamtW = PW, gesamtH = PH;
    var s;
    if (zyl) {
      // ganze Abwicklung zeigen: Henkel an beiden Enden, Druckfläche an ihrer Stelle
      var M = zylMasse(), fm = flaechenMitte();
      gesamtW = M.C; gesamtH = Math.max(M.H, PH);
      ox = (fm.mitte / 360) * M.C - PW / 2;
      var oy = fm.v * M.H - PH / 2;
      s = sv('svg', { viewBox: '0 ' + Math.min(0, oy) + ' ' + gesamtW + ' ' + gesamtH, class: 'lr-vf-blatt-svg', role: 'img', 'aria-label': 'Druckbild der Tasse als Abwicklung' });
      s.appendChild(sv('rect', { x: 0, y: 0, width: M.C, height: M.H, fill: '#fff', stroke: '#CFC6B8', 'stroke-width': M.C / 400 }));
      schraffurDef(s, M.C);
      var g = sv('g', {});
      g.appendChild(sv('rect', { x: ox, y: oy, width: PW, height: PH, fill: 'url(#lr-vf-schraffur)' }));
      druckInhalt(g, ox, oy, false);
      g.appendChild(sv('rect', { x: ox, y: oy, width: PW, height: PH, fill: 'none', stroke: '#8C7B66', 'stroke-width': M.C / 300, 'stroke-dasharray': (M.C / 90) + ' ' + (M.C / 140) }));
      s.appendChild(g);
      if (!S.bp.ohne_henkel) [0, M.C].forEach(function (x) { s.appendChild(sv('rect', { x: x - M.C * 0.012, y: M.H * 0.18, width: M.C * 0.024, height: M.H * 0.64, rx: M.C * 0.01, fill: '#B9AE9E' })); });
      wrap.appendChild(s);
      var leg = mk('div', 'lr-vf-legende');
      var ende = S.bp.ohne_henkel ? 'Naht' : 'Henkel';
      leg.innerHTML = '<span>' + ende + '</span><span>Druckfläche · ' + ausfuehrungName() + '</span><span>' + ende + '</span>';
      wrap.appendChild(leg);
    } else {
      var L1 = lage(); PW = gesamtW = L1.w; PH = gesamtH = L1.h;
      s = sv('svg', { viewBox: '0 0 ' + PW + ' ' + PH, class: 'lr-vf-blatt-svg', role: 'img', 'aria-label': 'Druckbild in Originalproportion' });
      schraffurDef(s, PW);
      s.appendChild(sv('rect', { x: 0, y: 0, width: PW, height: PH, fill: 'url(#lr-vf-schraffur)' }));
      var g2 = sv('g', {}); druckAufrecht(g2, 0, 0, false); s.appendChild(g2);
      s.appendChild(sv('rect', { x: 0, y: 0, width: PW, height: PH, fill: 'none', stroke: '#8C7B66', 'stroke-width': PW / 300, 'stroke-dasharray': (PW / 60) + ' ' + (PW / 90) }));
      if (S.bp && S.bp.seiten === 2) s.appendChild(sv('line', { x1: 0, y1: PH / 2, x2: PW, y2: PH / 2, stroke: '#8C7B66', 'stroke-width': PW / 250, 'stroke-dasharray': (PW / 40) + ' ' + (PW / 60) }));
      wrap.appendChild(s);
      var leg2 = mk('div', 'lr-vf-legende');
      leg2.innerHTML = '<span>Druckfläche · ' + ausfuehrungName() + '</span>';
      wrap.appendChild(leg2);
    }
    S.el.blattSvg = s; S.flachMass = [gesamtW, gesamtH];
    var ab = abdeckung();
    if (ab && ab.anteil < 0.985) {
      var h = mk('p', 'lr-vf-leer'); h.textContent = 'Schraffiert = bleibt unbedruckt (' + Math.round((1 - ab.anteil) * 100) + ' % der Druckfläche).';
      wrap.appendChild(h);
    }
    flachLayout();
  }
  function schraffurDef(s, breite) {
    var d = sv('defs', {}), p = sv('pattern', { id: 'lr-vf-schraffur', patternUnits: 'userSpaceOnUse', width: breite / 60, height: breite / 60, patternTransform: 'rotate(45)' });
    p.appendChild(sv('rect', { width: breite / 60, height: breite / 60, fill: '#F4F0EA' }));
    p.appendChild(sv('rect', { width: breite / 180, height: breite / 60, fill: '#D9CFC1' }));
    d.appendChild(p); s.appendChild(d);
  }
  function flachLayout() {
    var f = S.el.flach, b = S.el.blatt; if (!f || !b || f.hidden) return;
    var r = S.el.sicht.getBoundingClientRect(); if (!r.width) return;
    var m = S.flachMass || [1, 1], rand = 28, unten = 64;
    var k = Math.min((r.width - rand * 2) / m[0], (r.height - rand - unten) / m[1]);
    var s = S.el.blattSvg; s.style.width = Math.round(m[0] * k) + 'px'; s.style.height = Math.round(m[1] * k) + 'px';
  }

  /* ---------------- Hinweise ---------------- */
  function infoZeigen() {
    var i = S.el.info; if (!i) return;
    var ab = abdeckung(); var t = '';
    if (ab && ab.anteil < 0.985) t = 'Hinweis: ' + Math.round((1 - ab.anteil) * 100) + ' % der Druckfläche bleiben bei dieser Ausführung weiß.';
    if (S.bp && S.bp.hinweis) t = (t ? t + ' ' : '') + S.bp.hinweis;
    if (S.bp && S.bp.ohne_druck && S.bp.kalt_text) t = S.bp.kalt_text;
    S.infoArt = 'leer';
    i.textContent = t; i.hidden = !t || zeigtDruck();
  }
  function devZeigen() {
    var e = S.el.dev; if (!e) return;
    var t = (S.bp && S.bp.dev) || (S.prod && S.prod.dev) || '';
    if (!DEV) {
      /* Kunden: keine internen Notizen, nur ein ehrlicher Hinweis, wenn die Ansicht angenähert ist */
      e.classList.add('lr-vf-kunde');
      e.textContent = t ? 'Zur Orientierung · exakt: „Druckbild“' : '';
      e.hidden = !t || zeigtDruck();
      return;
    }
    if (S.pa) t = (t ? t + ' · ' : '') + 'Druckfläche ' + (S.pa.display_name || '') + ' ' + S.pa.width + '×' + S.pa.height + ' px';
    e.textContent = t ? 'Entwicklungsdaten: ' + t : ''; e.hidden = !t;
  }
  // Foto-Qualität: nie sperren, nur freundlich hinweisen (Lucas Regel „Fotos nie ablehnen“).
  // Gemessen wird die ORIGINALDATEI, die der Kunde wählt (teeinblues Vorschaubild ist nur ~960 px groß).
  function fotoGewaehlt(e) {
    var t = e.target;
    if (!t || t.type !== 'file' || !t.files || !t.files[0] || !t.closest || !t.closest('.tee-campaign, .teeinblue-item')) return;
    var f = t.files[0]; if (!/^image\//.test(f.type || 'image/')) return;
    // Originaldatei merken: nach einem Formatwechsel wird daraus neu zugeschnitten (nie das beschnittene Bild weiterverwenden)
    if (!S.eigenerUpload && f.arrayBuffer) f.arrayBuffer().then(function (b) { S.fotoDatei = { buf: b, name: f.name, type: f.type || 'image/jpeg' }; }).catch(function () {});
    S.eigenerUpload = false;
    var fertig = function (w, h) { S.fotoMass = w && h ? [w, h] : null; qualitaetPruefen(); };
    if (W.createImageBitmap) {
      createImageBitmap(f).then(function (bm) { var w = bm.width, h = bm.height; if (bm.close) bm.close(); fertig(w, h); }).catch(function () { fertig(0, 0); });
    } else {
      var u = URL.createObjectURL(f), i = new Image();
      i.onload = function () { fertig(i.naturalWidth, i.naturalHeight); URL.revokeObjectURL(u); };
      i.onerror = function () { fertig(0, 0); URL.revokeObjectURL(u); };
      i.src = u;
    }
  }
  function qualitaetPruefen() {
    infoZeigen();
    var m = S.fotoMass, pl = S.platz; if (!m || !pl) return;
    var r = pl.width / pl.height;                      // Seitenverhältnis der Foto-Ebene
    var nutzbarB = Math.min(m[0], m[1] * r);          // größtmöglicher Ausschnitt in diesem Verhältnis
    // Anteil = Fotopixel / Pixel der Druckdatei an dieser Stelle. Die Druckdateien haben je Produkt eine
    // andere Dichte (Poster/Tasse ~300 dpi, Decke 150×100 ~156 dpi) – deshalb keine dpi-Zahl anzeigen.
    var anteil = nutzbarB / pl.width;
    var min = (S.bp && S.bp.min_anteil) || 0.4;
    S.fotoAnteil = +anteil.toFixed(3);
    if (anteil < min && DEV) {                    // Kunden: Hinweis kommt von lr-konfig am Fotofeld, nicht über dem Produkt
      var i = S.el.info;
      i.textContent = 'Dein Foto hat für diese Größe eher wenig Pixel (' + m[0] + ' × ' + m[1] + '). Im Druck kann es weich wirken – am schärfsten wird es mit der Originaldatei vom Handy.';
      i.hidden = false; S.infoArt = 'dpi';
    }
  }

  /* ---------------- Prüfhilfe für Tests: Druckflächen-Punkt -> Bildschirm ---------------- */
  // (px, py) in Druckflächen-Pixeln. Ergebnis in Client-Koordinaten oder null (verdeckt/außerhalb).
  S.projiziere = function (px, py) {
    var bp = S.bp; if (!bp || bp.verfahren === 'druck' || !S.el.buehne) return null;
    var r = S.el.buehne.getBoundingClientRect(), k = S.k;
    var a = S.aus || bp.ausschnitt || [0, 0, bp.bildB, bp.bildH];
    var x, y;
    if (bp.verfahren === 'zylinder') {
      var z = bp.zyl, u = S.zylX + px, v = S.zylY + py;
      var th = ((u / S.zylC * 360 - S.d) % 360 + 540) % 360 - 180;
      if (Math.abs(th) > (z.thetaMax || 88) - 1 || v < 0 || v > S.zylH) return null;
      var c = Math.cos(rad(th)), top = z.oben_y + z.oben_b * c, bot = z.unten_y + z.unten_b * c;
      x = z.cx + z.r * Math.sin(rad(th)); y = top + (v / S.zylH) * (bot - top);
    } else {
      var PW = S.pa.width, PH = S.pa.height, fl = bp.flaeche_anteil;
      var uu = (px - (fl ? fl[0] * PW : 0)) / (fl ? fl[2] * PW : PW), vv = (py - (fl ? fl[1] * PH : 0)) / (fl ? fl[3] * PH : PH);
      if (uu < 0 || uu > 1 || vv < 0 || vv > 1) return null;
      var q = netzPunkt(uu, vv); x = q[0]; y = q[1];
      if (S.fx !== 1 && bp.anpassen) x = bp.anpassen.cx + (x - bp.anpassen.cx) * S.fx;
    }
    return [r.left + (x - a[0]) * k, r.top + (y - a[1]) * k];
  };
  S.projiziereFlach = function (px, py) {
    var s = S.el.blattSvg; if (!s || S.el.flach.hidden) return null;
    var r = s.getBoundingClientRect(), vb = s.viewBox.baseVal;
    var ox = 0, oy = 0;
    if (S.bp && S.bp.verfahren === 'zylinder') { var M = zylMasse(), fm = flaechenMitte(); ox = (fm.mitte / 360) * M.C - S.pa.width / 2; oy = fm.v * M.H - S.pa.height / 2; }
    return [r.left + (ox + px - vb.x) / vb.width * r.width, r.top + (oy + py - vb.y) / vb.height * r.height];
  };

  /* ---------------- Beobachten: Variante, Foto, Größe ---------------- */
  var pruefT = 0;
  function planPruefen() { clearTimeout(pruefT); pruefT = setTimeout(pruefen, 90); setTimeout(pruefen, 450); }
  function pruefen() {
    formateDeutsch(); doppelteFelder();
    var v = aktiveVariante(); if (!v) return;
    var dp = druckflaecheVon(v);
    var neuId = v.cv.variant_id, neuArt = dp && dp.platz ? dp.platz.artwork_id : null;
    var fehlt = S.artId && !artworkSvg(S.artId);
    if (!S.variante || neuId !== S.variante.cv.variant_id || (neuArt && String(neuArt) !== String(S.artId)) || fehlt) umbauen();
  }
  function beobachten() {
    D.addEventListener('change', planPruefen, true);
    D.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.tee-campaign, .teeinblue-item, [data-lr-reiter]')) planPruefen(); }, true);
    W.addEventListener('popstate', planPruefen);
    ['replaceState', 'pushState'].forEach(function (n) {
      var alt = history[n]; if (!alt || alt.__lrvf) return;
      var neu = function () { var r = alt.apply(this, arguments); planPruefen(); return r; };
      neu.__lrvf = true; history[n] = neu;
    });
    // Wird teeinblues Artwork-SVG ausgetauscht (anderes Artwork je Druckfläche), neu verknüpfen
    var a = artworkSvg(S.artId); var eltern = a && a.parentNode && a.parentNode.parentNode;
    if (eltern && W.MutationObserver) {
      var t = 0;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(pruefen, 200); }).observe(eltern, { childList: true, subtree: true });
    }
  }

  /* ---------------- Start ---------------- */
  function start() {
    var n = 0;
    (function versuch() {
      var tc = W.teeinblueCampaign;
      if (tc && tc.productId && $('.product-information__media') && $('svg[id^="tee-artwork-"]')) return init();
      if (++n < 90) setTimeout(versuch, 400);
    })();
  }
  function init() {
    S.pid = W.teeinblueCampaign.productId;
    /* Nur Fotogeschenke aus der Parameterliste – Poster behalten die Vorschau von Gestalter 8/9 */
    if (!Object.prototype.hasOwnProperty.call(PARAM.produkte || {}, String(S.pid))) return;
    kampagneLaden().then(function (c) {
      if (!c) return;
      S.camp = c; hochBestimmen();
      if (!geruest()) return;
      S.bildGroesse = (S.el.sicht.getBoundingClientRect().width * (W.devicePixelRatio || 1)) > 1250 ? 1600 : 1100;
      D.body.classList.add('lr-vf-seite');      // Fotogeschenk mit eigener Vorschau (für Layout-Anpassungen im CSS)
      umbauen();
      formateDeutsch(); setTimeout(formateDeutsch, 1500);
      doppelteFelder(); [700, 2000, 5000].forEach(function (t) { setTimeout(doppelteFelder, t); });
      beobachten();
      setTimeout(fotoWiederEinsetzen, 800);
    });
  }
  D.addEventListener('change', fotoGewaehlt, true);   // früh, damit auch ein sehr schneller Upload gemessen wird
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', start); else start();
})();
